import * as React from "react";
import * as _ from "lodash";
import {translate} from "react-i18next";
import * as Moment from "moment";
import {connect, Dispatch} from "react-redux";

// view container
import ViewContainer, {ICommonViewProps} from "../ViewContainer";

// components
import {makeSelectable, SelectableColumn} from "../../components/ColumnSelection";
import PslSelectionDialog, {PSLCopyType} from "./PSL/PslSelectionDialog";

// reducer
import {RouteComponentProps} from "react-router-dom";
import {ITypefamilyMap} from "../../redux/reducers/generalReducer";
import LinkName from "./LinkName";

// services
import {
    AssignedModeltypeBasicDto,
    AssignedModeltypeBasicDtoAssignmentType,
    AssignmentTransferDto,
    CnrDto,
    DtoListWithLinksOfOptionDto,
    ExcelDownloadResponseDto,
    ExcelExportResponseDto,
    HistoryDto,
    InitDto,
    LanguageDto,
    Link,
    MenuDto,
    MissingAssignmentsAndDerivateDTO,
    ModeltypeBasicDto,
    OptionBasicCoreDto,
    OptionBasicCoreDtoOptionType,
    OptionBasicDto,
    OptionDto,
    OptionDtoSpecificType,
    OptionFilterDto,
    OptionFlagMultiUpdateParam,
    OptionTextDto,
    OptionUpdateDto,
    OptionWorkflowStatusMultiUpdateParam,
    PSLCopyConflictDto,
    PSLCopyResultSummaryDto,
    ResourceListOfFlagDto,
    ResourceListOfModeltypeBasicDto,
    ResourceListOfModelyearDto,
    ResourceListOfOptionBasicDto,
    ResourceListOfOptionDto,
    ResourceListOfWorkflowOptionApprovalDto,
    RoleDto,
    SimpleOptionCopyDto,
    SpecificOptionInitDto,
    SpecificOptionInitDtoSpecificType,
    UpdateDraftAssignmentsDto,
    WorkflowDto,
    WorkflowOptionApprovalDto,
    WorkflowStatusDtoType
} from "../../services/Client";

import HATEOASClient, {
    GetOptionMTBAConflictsParams,
    GetOptionParams,
    GetPSLCopyConflictsParams,
    GetPSLCopyParams,
    GetPSLCopyStatsParams,
    GetPSLModeltypeBasicsParams,
    GetWorkflowOptionParams,
    PdipAssignedDerivatesParams,
} from "../../services/HATEOASClient";
import DataAdapterOptionsView from "./DataAdapterOptionsView";
import ColumnFactory from "../../services/ColumnFactory";
import {DerivateOptionColumnDefinition} from "../../components/DerivateOptionColumn";
import {DerivateStatesKey, OptionBasicViewKey, OptionIndicatorsKey} from "./OptionColumns";
import {IOptionsViewUserSettings, loadColumns, saveColumns, saveDerivateVisibility} from "./OptionsViewSettings";
import OptionsTableContainer from "./OptionsTableContainer";
import {
    AssignmentTypeFilter,
    ISelectFieldValue,
    ITextExportStatus,
    PSLChangeWorkflowParam,
    TData,
    TDataValue,
    TTableEditItem
} from "../../components/Table/VirtualizedTableInterfaces";

import ErrorBoundary from '../../utils/ErrorBoundary';
import {DropdownItemProps, Icon, MenuItemProps} from "semantic-ui-react";
import {base64toBlob, downloadExcel, EColumnKey, extractMultiFields, PDiPExcludedOptionTypes, PropertiesKey, SpecificFilterEnum, validateTexts} from "./OptionsViewUtils";
import {Dialog} from "../../components/Dialogs/Dialog";
import {Button} from "../../components/Button";
import MultiSelectDialog from "../../components/Table/components/modalDropdown/MultiSelectDialog";
import OptionDifferenceView from "../OptionDifferenceView/OptionDifferenceView";
import {EOptionState, getOptionStateCodes, TDerivateStates} from "../../components/DerivateOptionBar";
import ModeltypeBasicAssignmentsDialog from "./ModeltypeBasicAssignmentsDialog/ModeltypeBasicAssignmentsDialog";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import PSLCopyStatsDialog from "./PSL/PSLCopyStatsDialog";
import {PSLCopyConflictsDialog} from "./PSL/PSLCopyConflictsDialog";
import {PSLCopyResultSummaryDialog} from "./PSL/PSLCopyResultSummaryDialog";
import OptionsHeader from "./OptionsHeader/OptionsHeader";
import {toast} from "react-toastify";
import {ITableSort, sortOptions} from "../../utils/SortUtils";
import {IPSLApproval, IRowStatusProps} from "../../services/WorkflowUtils";
import {OptionAMTBTransferDialog} from "./amtbTransfer/OptionAMTBTransferDialog";
import ChangeWorkflowOptionDlg from "./workflowChange/ChangeWorkflowOptionDlg";
import {DerivateUtils} from "../../components/Table/components/derivate/DerivateUtils";
import UpdateWorkflowStatusMultiDialog from "./workflowStatusMultiUpdate/WorkflowStatusMultiUpdateDialog";
import {scrollGridToTop} from "../../components/Table/VirtualizedTableUtils";
import MultipleOptionDeletionDialog from "./multipleOptionDeletionDialog/MultipleOptionDeletionDialog";
import {PSLandPCCDSyncDialog} from "./checkPSLandPCCDSync/PSLandPCCDSyncDialog";
import UpdateDraftAssignmentsDialog from "./updateDraftAssignments/UpdateDraftAssignmentsDialog";
import DeleteConfirmDialog from "../../components/Dialogs/DeleteConfirmDialog";
import OptionViewActions from "../../redux/actions/OptionViewActions";
import GeneralActions from "../../redux/actions/GeneralActions";
import AdminViewActions from "../../redux/actions/AdminViewActions";
import {compose} from "redux";
import {IUserSettings} from "src/data/IUserSettings";
import UserSettingsDaemon from "src/services/UserSettingsDaemon";
import {IApplicationLink} from "src/data/IApplicationLink";
import {
    selectBaseLinks,
    selectClient,
    selectFlags,
    selectHideEmptyAssignmentsRowsAndColumns,
    selectLanguage,
    selectLanguageList,
    selectOptionTableSort,
    selectPslAreaExtraLinks,
    selectSettingDaemon,
    selectSwitchHeaderMode,
    selectUserCnrs,
    selectUserPSLModelyears,
    selectUserRoles,
    selectUserSettings,
    selectUserTypefamiliesMap,
    selectVirtualizedTableReload,
    selectWorkflows
} from "../../redux/selectors";
import {isDefinedPSLSelection, VIEWNAME} from "../../utils/GeneralUtils";
import {IPslSelection} from "./PSL/PslSelect";
import {ILocationTranslation, ITextAndIcon} from "src/components/GeneralInterfaces";
import {IError} from "src/components/FeedbackMessage";
import {IReduxState} from "src/redux/IReduxState";
import {HistoryDialog} from "../../components/Dialogs/HistoryDialog";
import {LanguageCodeEnum} from "../AdminView/LanguageTab/LanguageTable";
import FlagMultiUpdateDialog from "./MultipleFlagUpdate/FlagMultiUpdateDialog";
import {SYSTEM_USER, formatDate} from "src/components/Table/dataHandler/Utils";
import {getPSLColumnDefs} from "./AgGridOptionColumns";
import {PAGE_SIZE, setGridRenderStartTime} from "./util";

interface RouteProps {
    modelyear?: string;
    typefamily?: string;
    cnr?: string;
}

interface IMapDispatchToProps {
    AddTranslationLocation: (translation: ILocationTranslation) => void;
    ReceivePSLAreaExtraLinksAction: (extraLinks: any) => void;
    AddRecentDocument: (appLink: IApplicationLink) => void;
    DynTableSetSelectedIdList: (idList: string[]) => void;
    GetWorkflows: (t: reactI18Next.TranslationFunction) => void;
    GetTextFlags: (t: reactI18Next.TranslationFunction) => void;
    DynTableReload: (dynTableReload: boolean) => void;
    SetOptionTableSort: (sortObject: ITableSort) => void;
    RemoveLoadingMessage: (message: string) => void;
    AddLoadingMessage: (message: string) => void;
    SetHideEmptyAssignmentsRowsAndColumns: (value: boolean) => void;
    DynTableRollBack: (dynTabelRollback: boolean) => void;
    ChangeOptionsViewUserSettings: (newSettings: IOptionsViewUserSettings) => void;
    ReceiveInitDataAction: (dto: InitDto) => void;
}

interface IMapStateToProps {
    userSettings: IUserSettings;
    switchHeaderMode: boolean;
    baseLinks?: MenuDto;
    client: HATEOASClient;
    dynTableReload: boolean;
    optionTableSort: ITableSort;
    hideEmptyAssignmentsRowsAndColumns: boolean;
    userRoles?: RoleDto[];
    flags: ResourceListOfFlagDto;
    userCnrs: CnrDto[];
    pslAreaExtraLinks: MenuDto;
    settingsDaemon: UserSettingsDaemon;
    languageList?: LanguageDto[];
    workflows?: WorkflowDto[];
    userTypefamiliesMap: ITypefamilyMap;
    userPSLModelyears: ResourceListOfModelyearDto;
    userLanguage: string;
}

interface IOptionsViewProps extends
    ICommonViewProps,
    RouteComponentProps<RouteProps>,
    IMapStateToProps,
    IMapDispatchToProps {
    state: IReduxState;
}
interface DefaultColumnFilters {
    workflowFilters?: any[];
    optionTypeFilters?: any[];
    categoryFilters?: any[];
    flags?: any[];
    hasAssignment: string;
    [key: string]: any; // allow other dynamic keys
}
interface IOptionsViewState {
    showCompareDialog: boolean;

    /**
     * Values based on PCCD match(LAST EXPORTED VALUE)
     */
    pccdFlag?: boolean;

    /** contains the links of the Dto */
    postOptions?: ResourceListOfOptionDto;

    /** ModeltypeBasics for currently selected modeltype family */
    derivates: ModeltypeBasicDto[];

    /** Object with derivate as key and its color as value */
    derivateToColorMap: {[key: string]: string};

    /** All available columns of the options table. */
    optionColums: SelectableColumn[];

    /** Option objects as rows that can be passed to BasicDataGrid. */
    optionRows: Array<DataAdapterOptionsView>;

    /** Defines, if the table is in edit mode. */
    inEditMode: boolean;

    /** currently selected PSL */
    loadedPSL?: IPslSelection;

    /** defines if delete row is available (shows select column) */
    deleteable: boolean;

    /** defines if update row is available (shows select column) */
    updatable: boolean;

    /** currently selected item */
    selectedItem?: DataAdapterOptionsView;

    /** currently selected items */
    selectedItems: DataAdapterOptionsView[];

    /** shows select PSL dialog */
    isShowPSLSelectDialog: boolean;

    /** shows the dialog to confirm the deletion */
    isShowDeleteConfirmDialog: boolean;

    /** shows the dialog to copy and existing option */
    isShowCopyOptionDialog: boolean;

    /** shows the dialog to edit constraint and exclusion values for an option */
    isShowEditMultiselectItemDialog: boolean;

    /** shows the dialog to edit the derivate assignments for an option */
    isShowEditMTBAItemDialog: boolean;

    childOptions?: OptionDto[];

    /** list of flags that need to be replaced in status */
    statusFlags: Array<string>;

    excelIsGenerating: boolean;
    excelIsGeneratingV2: boolean;

    /** flag to trigger the excel export */
    exportExcel: boolean;

    /** defines if more than one item is selected */
    isMultiselectActive: boolean;

    /** the base options for the loaded MY that are used as datasource for constraint and exclusion */
    baseOptions: OptionBasicDto[];

    showCreateSpecificMarketDialog: boolean;

    /** the option for which the constraint or exclusion needs to be edited */
    editItem?: TTableEditItem;

    /** Contains the specific filter data for a specific market PSL */
    specificTypeOptionFilter: SpecificFilterEnum;

    /** Sets the value for the assignment dropdown filter */
    assignmentTypeFilter: AssignmentTypeFilter;

    /** Contains the modeltype basics that are not available for assignment(for update or copy of option)
     *  The key is the modeltype basic id and the value is a string list that contains the cnrs/markets
     *  where this modeltype basic is already assigned
     */
    optionMTBAConflicts?: {[key: number]: String[]} | null;

    /** Contains params for PSL copy */
    pslCopyContexts?: PSLCopyType;

    /** Whether or not to show the PSL copy disclaimer dialog */
    showPSLCopyDerivateDisclaimer: boolean;

    /** Whether or not to show the PSL copy stats dialog */
    showPSLCopyCnrsStats: boolean;

    /** Contains stats for PSL copy */
    pslCopyCnrsStats?: {[key: number]: number};

    /** Whether or not to show the PSL copy conflicts dialog */
    showPSLCopyConflicts: boolean;

    /** Contains conflicts for PSL copy */
    pslCopyConflicts?: PSLCopyConflictDto[];

    /** Whether or not to show the  PSL copy result dialog */
    showPSLCopyResultSummary: boolean;

    /** Contains a summary for the PSL copy action */
    pslCopyResultSummary?: PSLCopyResultSummaryDto;

    /** Whether or not to show the AMTB transfer dialog */
    showTransferAssignmentsDlg: boolean;

    /** A list of ids of options for which the amtb transfer failed */
    amtbTransferResult?: {[key: number]: string};

    /** Whether or not to show the dialog for updating draft assignments */
    showUpdateDraftAssignments: boolean;

    /** A list of ids of options for which the draft assignments update failed and the corresponding error message */
    updateDraftAssignmentsResult?: {[key: number]: string};

    /** Whether or not to show the dialog for changing an option's workflow */
    showChangeOptionWorkflowDlg: boolean;

    /** Contains data necessary for changing an option's workflow  */
    changeOptionWorkflowParam?: PSLChangeWorkflowParam;

    /** Whether or not to show the dialog for updating the workflow step for multiple options */
    showWorkflowStatusMultiUpdateDlg: boolean;

    /** Whether or not to show the dialog for deleting multiple options */
    showMultipleDeleteOptionDlg: boolean;

    /** The number of options for which the workflow status was not updated successfully */
    workflowStatusMultiUpdateErrorResult?: number;

    /** The options that could not be deleted */
    multipleOptionDeletionResult?: number[];

    /** Whether or not to show the dialog result for checking if a PSL is complete based on PCCD data */
    showCheckPCCDSyncResultDlg: boolean;

    /** Result for check if PSL is complete based on PCCD data */
    checkPCCDSyncResult?: MissingAssignmentsAndDerivateDTO;

    /** Show the history dialog */
    isShowHistoryDialog: boolean;

    /** Contains the history data for a selected item */
    selectedItemHistoryData?: HistoryDto[];

    selectedLanguageList?: LanguageDto[];

    languageList?: LanguageDto[];

    fieldKeyFilters: Set<string>;

    /** Contains the filtered history data for a selected item */
    selectedItemFilteredHistoryData?: HistoryDto[];

    /** Whether or not to show the dialog for updating the flags for multiple options */
    showMultipleUpdateFlagDlg: boolean;

    /** The number of options for which the workflow status was not updated successfully */
    flagMultiUpdateErrorResult?: number;

    // pdip assgined derivated
    pdipDerivates?: AssignedModeltypeBasicDto[];
    // show more history popup
    isShowMoreHistory?: boolean;
    // more histoy data
    moreHistoryData: HistoryDto[];
    isNewGridTable: boolean;
    onNewGridTableChange: (value: boolean) => void;
    pageSize: number;
    page: number;
    totalElements: number;
    rcMt: ResourceListOfModeltypeBasicDto;
    rcOB: any;
    rcLng: LanguageDto[];
    pageData: any;
    isLoadingData: boolean;
    newGridFilters?: any;
    newDropDownFilters?: any;
    agGridRef?: any;
    loadedRows: any;
    filterCount: number;
    currentMatchIndex: number;
    globalSearchText: string;
    generationsRows?: any[];

}

const createLinkForOptionsViewInternal = (psl?: IPslSelection): string => {
    let path: string = "/options";
    if (psl) {
        const {modelyear, typefamily, cnr} = psl;
        path = path.concat("/", modelyear.objectId.toString(), '/', typefamily.objectId.toString(), '/', cnr.objectId.toString());
        if (!psl.isNewTable) {
            psl.isNewTable = false;
        }
        path = path.concat("?isNewTable=", psl.isNewTable.toString());
    }
    return path;
};
const defaultColumnFilters: DefaultColumnFilters = {
    hasAssignment: 'false',
    isGlobalSearch: false,
    text: '',
    compareAssignments: [],
    pccdSync: null
};
class OptionsView extends React.Component<IOptionsViewProps, IOptionsViewState> {

    /** message if modifiing */
    modifiingMessage?: string; // not allowed in state!!!

    /**
     * For the data grid to display the data correctly,
     * scrolltop must be set to 0.
     * This variable indicates if this has already been done.
     */
    private alreadyScrolled = false;
    private latestRequestId = 0;

    private setDefaultFiltersNewGridTable = (props: IOptionsViewProps) => {
        // @ts-ignore
        const columnDefs = getPSLColumnDefs(props, [], false, null, {}); // Call to get column definitions
        columnDefs.forEach((column) => {
            if (column.field) {
                if (column.field === 'workflowFilters'
                    || column.field === 'optionTypeFilters'
                    || column.field === 'categoryFilters'
                    || column.field === 'flags') {
                    defaultColumnFilters[column.field] = []; // Initialize each field with an empty string
                } else if (column.field === 'availableStart'
                    || column.field === 'availableEnd'
                    || column.field === 'changedTimestamp') {
                    defaultColumnFilters[column.field] = null; // Initialize date fields with empty objects
                } else {
                    defaultColumnFilters[column.field] = ''; // Initialize each field with an empty string
                }

            }
        });
        return defaultColumnFilters;
    }
    constructor(props: IOptionsViewProps) {
        super(props);
        const settings = this.props.userSettings.optionsView;
        const params: any = new URLSearchParams(this.props.location.search);

        this.requestDatas = this.requestDatas.bind(this);
        this.redirectToPSL = this.redirectToPSL.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.createLinkName = this.createLinkName.bind(this);
        this.redirectToMain = this.redirectToMain.bind(this);
        this.toggleSetting = this.toggleSetting.bind(this);
        this.onChangeDerivateVisible = this.onChangeDerivateVisible.bind(this);
        this.handleColumnSelectionChanged = this.handleColumnSelectionChanged.bind(this);
        this.onChangeCell = this.onChangeCell.bind(this);
        this.onReorderColumns = this.onReorderColumns.bind(this);
        this.onRowSelectionChanged = this.onRowSelectionChanged.bind(this);
        this.onCheckRowSelectable = this.onCheckRowSelectable.bind(this);
        this.handleDeleteOption = this.handleDeleteOption.bind(this);
        this.handleCopyOption = this.handleCopyOption.bind(this);
        this.createIOspecificOption = this.createIOspecificOption.bind(this);
        this.onGridReadyParent = this.onGridReadyParent.bind(this);
        this.setDefaultFiltersNewGridTable = this.setDefaultFiltersNewGridTable.bind(this);
        this.state = {
            derivates: [],
            optionColums: loadColumns(settings, this.props, {
                [DerivateStatesKey]: {
                    editDerivates: settings.editDerivates,
                    showNotAvailableOptions: settings.showNotAvailableOptions,
                    onChangeDerivateVisible: this.onChangeDerivateVisible.bind(this),
                }
            }),
            statusFlags: ['!', '?'],
            optionRows: [],
            isShowPSLSelectDialog: false,
            inEditMode: false,
            deleteable: false,
            updatable: false,
            selectedItem: undefined,
            selectedItems: [],
            isShowCopyOptionDialog: false,
            isShowDeleteConfirmDialog: false,
            isShowEditMultiselectItemDialog: false,
            isShowEditMTBAItemDialog: false,
            excelIsGenerating: false,
            excelIsGeneratingV2: false,
            exportExcel: false,
            isMultiselectActive: false,
            baseOptions: [],
            showCreateSpecificMarketDialog: false,
            showCompareDialog: false,
            showPSLCopyDerivateDisclaimer: false,
            showPSLCopyCnrsStats: false,
            showPSLCopyConflicts: false,
            showPSLCopyResultSummary: false,
            specificTypeOptionFilter: SpecificFilterEnum.SHOW_ALL,
            assignmentTypeFilter: {filterValues: new Set<EOptionState>()},
            showTransferAssignmentsDlg: false,
            derivateToColorMap: {},
            showChangeOptionWorkflowDlg: false,
            showWorkflowStatusMultiUpdateDlg: false,
            showMultipleDeleteOptionDlg: false,
            showCheckPCCDSyncResultDlg: false,
            showUpdateDraftAssignments: false,
            isShowHistoryDialog: false,
            selectedItemHistoryData: undefined,
            selectedLanguageList: undefined,
            languageList: undefined,
            fieldKeyFilters: new Set<string>(),
            showMultipleUpdateFlagDlg: false,
            pdipDerivates: [],
            isShowMoreHistory: false,
            moreHistoryData: [],
            isNewGridTable: false,
            onNewGridTableChange: this.onNewGridTableChange.bind(this),
            pageSize: PAGE_SIZE,
            page: 1,
            totalElements: 0,
            rcMt: {},
            rcOB: {},
            rcLng: [],
            pageData: {},
            isLoadingData: false,
            newGridFilters: this.setDefaultFiltersNewGridTable(this.props),
            newDropDownFilters: {},
            agGridRef: null,
            loadedRows: new Set<number>(), // 👈 used to prevent duplicates
            filterCount: 0,
            currentMatchIndex: 0,
            globalSearchText: '',
            generationsRows: []
        };
    }

    private createLinkName(value: string, state: IReduxState): ITextAndIcon {
        return {
            text: '',
            icon: <LinkName value={value} redirectToPSL={(psl?: IPslSelection) => this.redirectToPSL(psl, true)} />
        };
    }

    componentDidMount() {
        this.props.AddTranslationLocation({pattern: "options", substitutes: "OPTIONS_VIEW"});
        this.props.AddTranslationLocation({
            pattern: new RegExp("options\/(.+)$"),
            substitutes:
                [
                    {
                        substitute: (val: any, state: any) => this.createLinkName(val, state)
                    }
                ]
        });

        if (this.props.baseLinks) {
            this.requestPSLExtraLinks(this.props.baseLinks);
        }

        this.reloadData(this.props);
    }

    componentWillReceiveProps(newProps: IOptionsViewProps) {
        if (newProps.userLanguage !== this.props.userLanguage) {
            this.mapDerivatesToColumn(this.state.derivates, newProps.userLanguage);
        }
        // handle settings change
        const oldSettings = this.props.userSettings.optionsView;
        const newSettings = newProps.userSettings.optionsView;
        if (oldSettings.editDerivates !== newSettings.editDerivates ||
            oldSettings.showNotAvailableOptions !== newSettings.showNotAvailableOptions) {
            const optionColums = this.patchDerivateColumn(this.state.optionColums, (column: DerivateOptionColumnDefinition) => {
                const newcol = {...column};
                newcol.editDerivates = newSettings.editDerivates;
                newcol.showNotAvailableOptions = newSettings.showNotAvailableOptions;
                return newcol;
            });
            this.setState({optionColums: optionColums});
        }

        const checkProps = _.uniq([...Object.keys(this.props.match.params), ...Object.keys(newProps.match.params)]);

        const checkState = ['baseLinks', 'languageList', 'userPSLModelyears', 'userCnrs', 'userTypefamiliesMap'];
        if (
            _.some(checkProps, p => this.props.match.params[p] !== newProps.match.params[p])
            || _.some(checkState, p => this.props[p] !== newProps[p])
        ) {
            if (this.state.isNewGridTable) {
                this.setState(
                    {
                        newGridFilters: this.setDefaultFiltersNewGridTable(newProps),
                        loadedRows: new Set<number>(),
                        page: 1,
                        totalElements: 0,
                        filterCount: 0,
                        currentMatchIndex: 0
                    },
                    () => {
                        this.reloadData(newProps);
                    }
                );
            } else {
                this.reloadData(newProps);
            }
        }
    }

    requestPSLExtraLinks = (baseLinks: MenuDto) => {
        if (this.props.client.GET_pslExtraLinks(baseLinks).canExecute()) {
            this.props.client.GET_pslExtraLinks(baseLinks).execute()
                .then((extraLinks: MenuDto) => {
                    this.props.ReceivePSLAreaExtraLinksAction(extraLinks);
                })
                .catch((reason: any) => {
                    window.scrollTo(0, 0);
                    renderErrorToast({
                        message: "ERRORS:GET_PSL_AREA_EXTRA_LINKS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    private onNewGridTableChange = (value: boolean) => {
        this.setState({isNewGridTable: value});
    }
    private onResetFilters = () => {
        // @ts-ignore
        const columnDefs = getPSLColumnDefs(this.props, [], false, null, {});
        columnDefs.forEach((column) => {
            if (column.field) {
                if (column.field === 'workflowFilters'
                    || column.field === 'optionTypeFilters'
                    || column.field === 'categoryFilters'
                    || column.field === 'flags') {
                    defaultColumnFilters[column.field] = [];
                } else if (column.field === 'availableStart'
                    || column.field === 'availableEnd'
                    || column.field === 'changedTimestamp') {
                    defaultColumnFilters[column.field] = null;
                } else {
                    defaultColumnFilters[column.field] = '';
                }
            }
        });
        defaultColumnFilters.text = '';

        this.setState(
            {
                newGridFilters: defaultColumnFilters,
                isLoadingData: true,
                loadedRows: new Set(),
                optionRows: [],
                currentMatchIndex: 0, // reset search match index,
                globalSearchText: '',
                assignmentTypeFilter: {filterValues: new Set()}
            },
            () => {
                this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
                if (this.state.agGridRef && this.state.agGridRef.api) {
                    this.state.agGridRef.api.setFilterModel(null); // clear all filters
                    this.state.agGridRef.api.refreshHeader();      // force re-render of header & floating filters
                }
            }
        );
    }
    private reloadData(props: IOptionsViewProps) {
        // take care the properties b.elow are contained in checkState!!!
        const {
            baseLinks,
            workflows,
        } = props;
        const languageList = this.state.selectedLanguageList;

        if (!baseLinks || !workflows) {
            // do nothing
        } else {
            const link = props.match.params;
            const pslTemp = LinkName.decodeLink(link, props);
            if (isDefinedPSLSelection(pslTemp) && languageList) {
                this.setState({isNewGridTable: pslTemp.isNewTable === "true" ? true : false});
                // @ts-ignore
                const psl = pslTemp as IPslSelection;
                const path = createLinkForOptionsViewInternal(psl);
                const modelYearDesc = `PSL_LINK/MODELYEAR:${ColumnFactory.mj2str(psl.modelyear)}`;
                const typeFamilyDesc = `/TYPEFAMILY:${psl.typefamily.key}`;
                const cnrDesc = `/CNR:${psl.cnr.name}`;

                this.props.AddRecentDocument({
                    href: path,
                    description: `${modelYearDesc}${typeFamilyDesc}${cnrDesc}?isNewTable=${this.state.isNewGridTable}`
                });

                // remove selected data
                this.props.DynTableSetSelectedIdList([]);

                // also reload workflows
                this.props.GetWorkflows(props.t);

                // reload flags
                this.props.GetTextFlags(props.t);
                this.requestDatas(props, psl, this.state.agGridRef);
                return;
            } else {
                this.setState({isShowPSLSelectDialog: true});
            }
        }
    }

    private redirectToMain(error?: IError) {
        this.props.history.replace({
            pathname: "/",
            state: {error}
        }); // redirect to main
        if (error) {
            renderErrorToast(error);
        }
    }

    private redirectToPSL(psl?: IPslSelection, replace: boolean = false): void {
        const path = createLinkForOptionsViewInternal(psl);
        replace ? this.props.history.replace(path) : this.props.history.push(path);
    }

    private onLoadPsl = (psl: IPslSelection) => {
        this.setState({isShowPSLSelectDialog: false, inEditMode: false}, () => this.redirectToPSL(psl, true));
    }

    /**
     * insert some informations to derivate columns
     * @param optionColums columns
     * @param predicate function to be applied on the derivate column
     */
    private patchDerivateColumn(optionColums: SelectableColumn[], predicate: (column: DerivateOptionColumnDefinition) => DerivateOptionColumnDefinition): SelectableColumn[] {
        let columns = optionColums.map((column, index) => {
            if (!ColumnFactory.isDerivateColumn(column)) {
                return column;
            } else {
                const newcol = predicate(column);
                return makeSelectable(newcol, column.visible);
            }
        });
        return columns;
    }

    private patchDerivatesToColumn(column: DerivateOptionColumnDefinition, derivates: Map<number, string>): DerivateOptionColumnDefinition {
        const newcol = {...column};
        newcol.derivates = derivates;
        newcol.width = derivates.size * 25;
        newcol.editDerivates = this.props.userSettings.optionsView.editDerivates;
        newcol.hideDerivates = this.props.userSettings.optionsView.hiddenDerivates;
        return newcol;
    }

    componentDidUpdate(prevProps: Readonly<IOptionsViewProps>): void {
        if (this.props.languageList && !this.state.selectedLanguageList) {
            const defaultLanguages = this.props.languageList
                .filter(lang => [LanguageCodeEnum.BASIC_GERMAN.toString(), LanguageCodeEnum.BASIC_ENGLISH.toString()]
                    .indexOf(lang.vmce) >= 0);
            this.setState({selectedLanguageList: defaultLanguages}, () => {
                this.reloadData(this.props);
            });
        }

        if (this.props.dynTableReload) {
            this.reloadData(this.props);
            this.props.DynTableReload(false);
        }

        if (this.props.match.params.modelyear !== prevProps.match.params.modelyear
            || this.props.match.params.cnr !== prevProps.match.params.cnr
            || this.props.match.params.typefamily !== prevProps.match.params.typefamily
        ) {
            this.setState({specificTypeOptionFilter: SpecificFilterEnum.SHOW_ALL, assignmentTypeFilter: {filterValues: new Set()}});
        }

        if (prevProps.optionTableSort.thirdKey !== this.props.optionTableSort.thirdKey
            || prevProps.optionTableSort.thirdKeyAsc !== this.props.optionTableSort.thirdKeyAsc
            || prevProps.optionTableSort.intSequence !== this.props.optionTableSort.intSequence
            || prevProps.optionTableSort.categoryText !== this.props.optionTableSort.categoryText
        ) {
            this.setState(
                {
                    optionRows: sortOptions(this.state.optionRows, this.props.optionTableSort),
                    selectedItems: [],
                    selectedItem: undefined,
                },
                () => this.props.DynTableSetSelectedIdList([])
            );
        }

        if (!this.alreadyScrolled && this.state.optionRows && this.state.optionRows.length > 0) {
            const element = document.getElementsByClassName("react-grid-Canvas");
            if (element.length > 0 && element[0] !== undefined) {
                element[0].scrollTop = element[0].scrollHeight;
                element[0].scrollTop = 0;
                this.alreadyScrolled = true;
            }
        }
        setTimeout(
            () => {
                const matches = Array.from(document.querySelectorAll('[style*="background-color: yellow"], [style*="background: yellow"]'));
                if (matches.length > 0) {
                    this.scrollToMatch(this.state.currentMatchIndex, matches);
                }
            },
            0
        );
    }

    componentWillUnmount(): void {
        this.props.SetOptionTableSort({categoryText: true, intSequence: true});
    }

    private setModifiing(val?: string) {
        if (this.modifiingMessage) {
            this.props.RemoveLoadingMessage(this.modifiingMessage);
            this.modifiingMessage = undefined;
        }
        if (val) {
            this.props.AddLoadingMessage(val);
            this.modifiingMessage = val;
        }
    }

    private async requestChildOptions(optionDto: OptionDto): Promise<boolean> {

        const roOptionChilds = this.props.client.GET_optionChilds(optionDto);

        if (roOptionChilds.canExecute()) {
            return await roOptionChilds.execute().then((res: any) => {
                this.setState({childOptions: res});
                return true;
            }).catch((reason: any) => {
                renderErrorToast({
                    message: "ERRORS:ERROR_LOADING_CHILD_OPTIONS",
                    details: reason,
                    timestamp: Date.now()
                });
                return false;
            });
        } else {
            renderErrorToast({
                message: "ERRORS:ERROR_LOADING_CHILD_OPTIONS",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return false;
        }
    }

    private mapDerivatesToColumn(derivates: ModeltypeBasicDto[], userLanguage: string) {
        let derivatesNames: Map<number, string> = DataAdapterOptionsView.createDerivatesList(derivates, userLanguage);
        const derivateToColorMap = {};
        // @ts-ignore
        derivates.map(derivate => derivateToColorMap[derivate.objectId] = derivate.color);
        // inserts derivates to derivates columns
        const optionColumns = this.patchDerivateColumn(
            this.state.optionColums,
            (column: DerivateOptionColumnDefinition) =>
                this.patchDerivatesToColumn(column, derivatesNames));

        this.setState({
            optionColums: optionColumns,
            derivateToColorMap
        });
    }

    /** calls GET_optionList and GET_modeltypeBasicList */
    private requestDatas(props: IOptionsViewProps, psl: IPslSelection, gridParams?: any) {
        const {t} = props;
        const {client, workflows, userCnrs, userLanguage} = props;

        const {modelyear, cnr} = psl;
        this.setModifiing(t("LOAD_MODELTYPE_BASICS_AND_OPTIONS"));
        this.setState({isShowPSLSelectDialog: false, loadedPSL: psl});

        const roMTB = client.GET_modeltypeBasicPSLList(modelyear);
        const roOptions = client.GET_optionList(modelyear);
        const roBaseOptions = client.GET_optionBasicList(modelyear);
        const roCnrSpecificLanguages = client.GET_cnrAssignedLanguages(cnr);

        const params =
        {
            modelYear: ColumnFactory.mj2str(modelyear)
        };
        let errMsg = "ERRORS:GET_MODELYEAR_DATA";

        if (!workflows) {
            renderErrorToast({
                message: errMsg,
                translationOptions: params,
                details: "ERRORS:NO_WORKFLOWS",
                timestamp: Date.now()
            });
            this.setModifiing();
            return;
        }

        if (!roMTB.canExecute() || !roOptions.canExecute() || !roBaseOptions.canExecute() || !roCnrSpecificLanguages.canExecute()) {
            renderErrorToast({
                message: errMsg,
                translationOptions: params,
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            this.setModifiing();
            this.setState({
                deleteable: false,
                updatable: false
            });
            return;
        }

        let optionDto: GetOptionParams = {
            cnrId: psl.cnr.objectId,
            typefamilyId: psl.typefamily.objectId,
            metadata: true,
        };

        let mtbParams: GetPSLModeltypeBasicsParams = {
            typeFamilyId: psl.typefamily.objectId,
            cnrId: psl.cnr.objectId
        };

        // reset the filter
        if (this.props.hideEmptyAssignmentsRowsAndColumns) {
            this.props.SetHideEmptyAssignmentsRowsAndColumns(false);
        }
        const isNewTable = psl.isNewTable.toString(); // Ensure boolean value
        const promises = [
            roMTB.execute(mtbParams),
            isNewTable === 'true' ? undefined : roOptions.execute(optionDto), // Conditionally exclude this
            roBaseOptions.execute(),
            roCnrSpecificLanguages.execute()
        ].filter(Boolean) as Promise<any>[]; // Remove undefined values

        Promise.all(promises)
            .then(async (response: [ResourceListOfModeltypeBasicDto, ResourceListOfOptionDto | null, ResourceListOfOptionBasicDto, LanguageDto[]]) => {
                const [rcMt, rcO, rcOB, rcLng] = isNewTable === 'true'
                    ? [response[0], null, response[1], response[2] as LanguageDto[]] // Shift indices if `isNewTable` is true
                    : response;
                this.setState({rcMt, rcOB, rcLng, loadedPSL: psl});
                if (isNewTable === 'false') {
                    this.processData(rcO);
                } else if (gridParams) {
                    const {baseLinks} = this.props;
                    if (baseLinks) {
                        const reqStatsParam: GetPSLCopyStatsParams = {
                            modelyearId: psl.modelyear.objectId,
                            typefamilyId: psl.typefamily.objectId
                        };
                        const newDropDownFilters: any = await client.GET_pslFilters(baseLinks).execute(reqStatsParam);
                        // Extract workflowFilters and ensure it's an array
                        const workflowFilters = Array.isArray(newDropDownFilters.workflowFilters)
                            ? newDropDownFilters.workflowFilters
                            : [];
                        // Create a collection with unique wfId items
                        const uniqueItems = [];
                        const seen = new Set();

                        for (const item of workflowFilters) {
                            if (!seen.has(item.wfStatusName)) {
                                seen.add(item.wfStatusName);
                                uniqueItems.push(item);
                            }
                        }
                        newDropDownFilters.uniqueWorkflowFilters = uniqueItems;
                        this.setState({newDropDownFilters});
                        this.loadNewGridData(this.state.page, PAGE_SIZE, gridParams, true);
                    }
                }
            }).catch((reason: any) => {
                this.setState(
                    {
                        deleteable: false,
                        updatable: false,
                        postOptions: undefined,
                        optionRows: []
                    });
                renderErrorToast({
                    message: errMsg,
                    translationOptions: params,
                    details: reason,
                    timestamp: Date.now()
                });
                this.setModifiing();
            });
    }

    onPageChange = (newPage: number, gridApi: any) => {
        this.setState({page: newPage, isLoadingData: true});
        this.loadNewGridData(newPage, PAGE_SIZE, gridApi);
    }
    onLazyLoad = (gridApi: any) => {
        const currentPage = this.state.page;
        const newPage = currentPage + 1;
        this.setState({page: newPage});
        this.onPageChange(newPage, gridApi);
    }
    loadNewGridData = async (
        page: number,
        pageSize: number,
        gridParams?: any,
        isFirstLoad: boolean = false
    ) => {
        const datasource = {
            getRows: async (params: any) => {
                const requestId = ++this.latestRequestId;
                const {startRow, endRow} = params;
                const {loadedPSL, newGridFilters} = this.state;

                if (!loadedPSL) {
                    params.successCallback([], 0);
                    return;
                }

                const pslData = {
                    modelyear: loadedPSL.modelyear.objectId,
                    typefamilyId: loadedPSL.typefamily.objectId,
                    cnrId: loadedPSL.cnr.objectId,
                };

                try {
                    this.setModifiing();
                    gridParams.api.showLoadingOverlay();
                    const res = await this.props.client.getOptionUsingPagination(
                        newGridFilters,
                        pslData,
                        Math.floor(startRow / pageSize),
                        pageSize
                    );
                    gridParams.api.hideOverlay();
                    if (requestId !== this.latestRequestId) return;

                    const {rows, deleteable, updatable, baseOptions, rcLng, rest, derivates} = this.getUpdatedRows(res);
                    const [updatedData,optionDtos,generationsRows] = this.buildData(rows);
                    const fetchedTotal = res.totalElements;
                    const isLastPage = startRow + updatedData.length >= fetchedTotal;
                    const lastRow = isLastPage ? fetchedTotal : -1;
                    const startIdx = startRow;
                    const endIdx = startRow + updatedData.length;

                    // Track loaded rows to avoid double-counting
                    const newLoadedRows = new Set(this.state.loadedRows);
                    for (let i = startIdx; i < endIdx; i++) {
                        newLoadedRows.add(i);
                    }
                    if (this.state.totalElements === 0 || isFirstLoad) {
                        this.setState({totalElements: fetchedTotal, filterCount: fetchedTotal});
                    }
                    if (isFirstLoad || fetchedTotal !== this.state.totalElements) {
                        this.setState({
                            derivates,
                            optionRows: [...this.state.optionRows, ...rows],
                            loadedRows: newLoadedRows,
                            filterCount: fetchedTotal,
                            postOptions: rest,
                            baseOptions,
                            selectedItems: rows,
                            deleteable,
                            updatable,
                            rcLng,
                            generationsRows
                        });
                    } else {
                        this.setState((prevState) => ({
                            derivates,
                            optionRows: [...prevState.optionRows, ...rows],
                            loadedRows: newLoadedRows,
                            filterCount: fetchedTotal,
                            baseOptions,
                            selectedItems: rows,
                            deleteable,
                            updatable,
                            rcLng,
                            generationsRows
                        }));
                    }
                    // Before you call params.successCallback
                    setGridRenderStartTime();
                    params.successCallback(updatedData, lastRow);

                } catch (error) {
                    console.error("Error loading data:", error);
                    params.failCallback();
                    this.setState({isLoadingData: false});
                }
            },
        };

        gridParams.api.setDatasource(datasource);
        gridParams.api.purgeInfiniteCache(); // ✅ Clear previous rows
    }
    onGridReadyParent = (params: any) => {
        const link = this.props.match.params;
        const pslTemp = LinkName.decodeLink(link, this.props);
        if (isDefinedPSLSelection(pslTemp) && this.state.selectedLanguageList) {
            this.setState({isNewGridTable: pslTemp.isNewTable === "true" ? true : false});
            // @ts-ignore
            const psl = pslTemp as IPslSelection;
            this.setState({agGridRef: params});
            this.requestDatas(this.props, psl, params);
        }
    }
    private buildStatusView(
        item: DataAdapterOptionsView,
        isSpecificMarketLoaded: boolean,
        itemHasSpecificCnr: boolean
    ): IRowStatusProps {
        return {
            statusValueState: item.statusValueState,
            statusValueStateEditable: item.statusValueStateEditable,
            statusValueStateResetable:
                item.specificType !== undefined &&
                    item.specificType === OptionDtoSpecificType.DEPENDENT_OVERWRITE
                    ? false
                    : item.statusValueStateResetable,
            statusValueStates: item.statusValueStates,
            statusView: item.statusView,
            resetRoles: item.statusResetRoles,
            workFlowName: item.workFlowName,
            workflowType: item.workflowType,
            workflowResetPointRejection: item.workflowResetPointRejection,
            isDependentOverwriteSpecific:
                isSpecificMarketLoaded &&
                    itemHasSpecificCnr &&
                    item.specificType &&
                    item.specificType === OptionDtoSpecificType.DEPENDENT_OVERWRITE
                    ? true
                    : false,
            invalidTexts:
                item.statusView === WorkflowStatusDtoType.MAINTENANCE
                    ? !validateTexts(item.texts)
                    : undefined,
            statusStepIndex:
                item.statusView === WorkflowStatusDtoType.MAINTENANCE
                    ? item.statusValueStates
                        ? item.statusValueStates.findIndex((s) => s.id === item.statusValueState)
                        : undefined
                    : undefined,
            hasChangeWfButton:
                !isSpecificMarketLoaded ||
                (itemHasSpecificCnr &&
                    item.specificType &&
                    (item.specificType === OptionDtoSpecificType.INDEPENDENT_OVERWRITE ||
                        item.specificType === OptionDtoSpecificType.COPY))
        };
    }
    private buildData(data: DataAdapterOptionsView[]): [TData[], OptionDto[], any[]] {
        const optionDtos: OptionDto[] = [];
        let generationsRows: any = [];
        const isSpecificMarketLoaded = this.isSpecificMarket();
        const tableData = data.map((item: DataAdapterOptionsView): any => {
            const isDisabled: boolean = isSpecificMarketLoaded === true && item.cnr !== undefined && item.cnr.cnr === PropertiesKey.BasicMarketCnrKey ? true : false;
            const isSpecificOption: boolean = isSpecificMarketLoaded === true && item.cnr !== undefined && item.cnr.cnr !== PropertiesKey.BasicMarketCnrKey ? true : false;
            const itemHasSpecificCnr = item.cnr && item.cnr.cnr !== PropertiesKey.BasicMarketCnrKey;

            const statusView: IRowStatusProps = this.buildStatusView(item, isSpecificMarketLoaded || false, itemHasSpecificCnr || false);

            const exportStatus: ITextExportStatus = {
                textExportDate: item.textExportDate,
                textExportStatus: item.textExportStatus,
                textExportStatusMessage: item.textExportStatusMessage
            };

            optionDtos.push(item.dto);
            if (item.optionIndicators && item.optionIndicators.dto && item.optionIndicators.dto.modeltypes) {
                const modeltypes = item.optionIndicators.dto.modeltypes
                    .filter((modeltype) => modeltype.modeltypeBasic && modeltype.modeltypeBasic.generation !== undefined)
                    .map((modeltype) => {
                        return {
                            generation: modeltype.modeltypeBasic.generation,
                            objectId: modeltype.modeltypeBasic.objectId,
                            child: []
                        };
                    });

                if (modeltypes.length > 0) {
                    modeltypes.forEach((modeltype) => {
                        const isItemExist = generationsRows.find((generationRow: any) => generationRow.objectId === modeltype.objectId);
                        if (!isItemExist) {
                            const alreadyAddedGeneration = generationsRows.find((generationRow: any) => generationRow.generation.objectId === modeltype.generation.objectId);
                            if (!alreadyAddedGeneration) {
                                generationsRows.push(modeltype);
                            } else {
                                const alreadyNotAChild = alreadyAddedGeneration.child.find((child: any) => child.objectId === modeltype.objectId);
                                if (!alreadyNotAChild) {
                                    alreadyAddedGeneration.child.push(modeltype);
                                }
                            }
                        }
                    });
                }
            }
            return {
                optionBasicView: item.optionBasicView,
                derivateStates: item.derivateStates,
                availableEnd: item.availableEnd ? Moment(item.availableEnd, "DD.MM.YYYY", "de") : undefined,
                availableStart: item.availableStart ? Moment(item.availableStart, "DD.MM.YYYY", "de") : undefined,
                categoryText: item.categoryText.text.length > 0 ?
                    item.categoryText.text : item.optionBasic.category,
                comment: item.comment,
                constraint: item.constraint,
                price: item.price,
                optionTypeView: this.props.t("GLOBAL:" + item.optionTypeView) + " (" + item.optionTypeView + ')',
                optionType: item.optionBasic.optionType,
                statusView: statusView,
                shorttext: extractMultiFields(item, "shorttext"),
                longtext: extractMultiFields(item, "longtext"),
                shortPCCDtext: extractMultiFields(item, "shortPCCDtext"),
                longPCCDtext: extractMultiFields(item, "longPCCDtext"),
                // optionTextPCCDExports: item.dto.optionTextPCCDExports,
                footer: extractMultiFields(item, "footer"),
                usp: extractMultiFields(item, "usp"),
                pdiptext: item.optionBasic.pdiptext,
                exclusion: item.exclusion,
                packageContent: item.packageContent,
                flags: {
                    options: this.props.flags.elements
                        ? this.props.flags.elements.map(flag => ({text: flag.textLabel, value: flag.objectId}))
                        : [],
                    value: item.flags ? item.flags : [],
                },
                optionIndicators: item.optionIndicators,
                reference: item.reference,
                referenceExc: item.referenceExc,
                intSequence: item.intSequence,
                exportStatus: exportStatus,
                cnr: item.cnr,
                specificType: item.specificType,
                isDisabled: isDisabled,
                rowClass: isSpecificOption ? 'row-' + item.specificType :
                    PDiPExcludedOptionTypes.has(item.optionBasic.optionType) ? 'table-invalid-pdip-option-type-row' : 'table-invalid-pdip-row',
                parentOptionId: item.parentOptionId,
                objectId: item.objectId,
                pdipFlag: item.dto.pdipFlag,
                pccdFlag: item.dto.pccdFlag,
                missingPDiPAMTBs: item.getMissingPDiPAMTBs(),
                changedBy: item.changedBy === SYSTEM_USER ? this.props.t("GLOBAL:SYSTEM_USER") : item.changedBy,
                changedTimestamp: item.changedTimestamp ? formatDate(item.changedTimestamp) : undefined
                // add here wath you need to send
            };
        });
        generationsRows = generationsRows.sort((a: any, b: any) => a.generation.generation.localeCompare(b.generation.generation));
        return [tableData, optionDtos, generationsRows];
    }
    getUpdatedRows = (data: any) => {
        // extract derivates
        const {rcMt, rcOB, rcLng} = this.state;
        const languageList = this.state.selectedLanguageList;
        const {client, workflows, userCnrs, userLanguage} = this.props;
        let derivates = !rcMt.elements ? [] : rcMt.elements.sort(DerivateUtils.compareBySequenceAndBtyp);
        if (derivates) {
            derivates = derivates.filter((derivate: any) => derivate.visible);
        }
        const derivatesMap = DataAdapterOptionsView.createIdToDerivateMap(derivates, userLanguage);
        this.mapDerivatesToColumn(derivates, userLanguage);

        // extract base options
        const baseOptions = rcOB && rcOB.elements ? rcOB.elements : [];
        // extract options
        const {elements, ...rest} = data || {elements: []};
        let optEls = elements;
        let deleteable: boolean = false;
        let updatable: boolean = false;
        let rows = !optEls ? [] : optEls.map((option: any) => {
            if (!deleteable) {
                // check if at least one element is deletable
                deleteable = client.DELETE_option(option).canExecute();
            }
            if (!updatable) {
                // check if at least one element is deletable
                updatable = this.props.client.PATCH_option(option).canExecute();
            }
            if (!workflows) return;
            return new DataAdapterOptionsView(option, derivates, derivatesMap, workflows, languageList || [], userCnrs || []);
        });
        return {rows, deleteable, updatable, rest, baseOptions, rcLng, derivates};
    }
    processData = (data: any) => {
        const {rows, deleteable, updatable, baseOptions, rcLng, rest, derivates} = this.getUpdatedRows(data);
        let optionRows: any = [];
        if (!this.state.isNewGridTable) {
            const rowwWithIntSqunece = rows.filter((row: any) => row.intSequence);
            const rowWithPromtSequence = rowwWithIntSqunece.filter((row: any) => row.optionIndicators
                && row.optionIndicators.dto
                && row.optionIndicators.dto.optionBasic.categoryText.proMTSequence);
            optionRows = sortOptions(rowWithPromtSequence, this.props.optionTableSort);
            const withoutPromtSqunce = rows.filter((item: any) => item.optionIndicators.dto.optionBasic.categoryText.proMTSequence === undefined);
            const withoutPccd = rows.filter((row: any) => !row.intSequence);
            optionRows = optionRows.concat(withoutPromtSqunce, withoutPccd);
        }

        this.setState({
            deleteable,
            updatable,
            postOptions: rest,
            derivates: derivates,
            optionRows,
            baseOptions: baseOptions as OptionBasicDto[],
            selectedItem: undefined,
            selectedItems: [],
            languageList: rcLng,

        });
        if (!this.state.isNewGridTable) {
            setTimeout(
                () => {
                    this.setState({optionRows});
                },
                1000);

            setTimeout(
                () => {
                    this.setModifiing();
                },
                5000);
        } else {
            this.setModifiing();
            this.setState({isLoadingData: false});
        }
    }

    onNewFilterChange = (field: string, value: any) => {
        const updatedFilters = {...this.state.newGridFilters};
        if (value) {
            if (field === 'categoryFilters') {
                const selectedCategories = Array.isArray(value) ? value : value.split(',');
                updatedFilters[field] = selectedCategories;
            } else if (field === 'optionTypeFilters') {
                const selectedOptionTypes = Array.isArray(value) ? value : value.split(',');
                updatedFilters[field] = selectedOptionTypes.map((optionType: any) => {
                    return this.state.newDropDownFilters.optionTypeFilters.find(
                        (item: any) => item.name === optionType
                    ).name;
                });
            } else if (field === 'uniqueWorkflowFilters') {
                field = 'workflowFilters';
                const selectedStatusIds = Array.isArray(value) ? value : value.split(',');

                // Collect all workflow steps from all workflows that match any selected status name
                const allMatchingSteps: any[] = [];
                selectedStatusIds.forEach((statusId: any) => {
                    // Find the wfStatusName for the selected wfStatusId
                    const selectedStep = this.state.newDropDownFilters.uniqueWorkflowFilters.find(
                        (item: any) => item.wfStatusId === Number(statusId)
                    );
                    if (selectedStep) {
                        // Find all workflow steps with the same wfStatusName
                        this.state.newDropDownFilters.workflowFilters.forEach((item: any) => {
                            if (item.wfStatusName === selectedStep.wfStatusName) {
                                allMatchingSteps.push(item);
                            }
                        });
                    }
                });
                updatedFilters[field] = allMatchingSteps;
            } else if (field === 'flags') {
                updatedFilters[field] = typeof value === 'string' ? value.split(',') : value;
            } else {
                updatedFilters[field] = value;
            }
        } else {
            if (field === 'uniqueWorkflowFilters') {
                field = 'workflowFilters';
            }
            delete updatedFilters[field];
        }
        // Set loading state and fetch new data in the callback
        this.setState(
            {newGridFilters: updatedFilters, isLoadingData: true, loadedRows: new Set(), optionRows: []},
            () => {
                this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
            }
        );
    }
    private onFilterByComparingAssignmentsChange = (values: number[]) => {
        const updatedFilters = {...this.state.newGridFilters};
        updatedFilters.compareAssignments = values;
        this.setState(
            {
                newGridFilters: updatedFilters,
                isLoadingData: true,
                loadedRows: new Set(),
                optionRows: []
            },
            () => {
                this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
            }
        );
    }
    private onFilterPccdSyncDataChange = (value: boolean | null) => {
        const updatedFilters = {...this.state.newGridFilters};
        updatedFilters.pccdSync = value;
        this.setState(
            {
                newGridFilters: updatedFilters,
                isLoadingData: true,
                loadedRows: new Set(),
                optionRows: []
            },
            () => {
                this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
            }
        );
    }

    renderPslSelectionDialog = (): JSX.Element => {
        return (
            <PslSelectionDialog
                onPslSelected={this.onLoadPsl}
                onCopyPsl={this.onPSLCopyClick}
                onCancel={() => this.props.history.goBack()}
                userHasBasicMarketCnrAssigned={this.props.userCnrs.find(cnr => cnr.cnr === PropertiesKey.BasicMarketCnrKey) !== undefined}
                userHasSpecificCnrsAssigned={this.props.userCnrs.find(cnr => cnr.cnr !== PropertiesKey.BasicMarketCnrKey) !== undefined}
                isNewGridTable={this.state.isNewGridTable}
                onNewGridTableChange={this.onNewGridTableChange}
            />
        );
    }

    renderOptions = (): JSX.Element => {
        const {
            optionColums,
            optionRows,
            inEditMode,
            updatable,
            assignmentTypeFilter,
            exportExcel,
            postOptions,
            loadedPSL,
            derivateToColorMap,
            specificTypeOptionFilter,
            selectedLanguageList,
            isNewGridTable
        } = this.state;
        const isNewTable = loadedPSL && loadedPSL.isNewTable.toString();
        if (optionRows.length === 0 && specificTypeOptionFilter === SpecificFilterEnum.SHOW_ALL && isNewTable === 'false') {
            return (<div className='no-data-message'> {this.props.t("NO_DATA")} </div>);
        }

        let isSpecificMarketLoaded: boolean | undefined = this.isSpecificMarket();
        return (
            <div className="options-view">
                <OptionsTableContainer
                    isNewGridTable={isNewGridTable}
                    userRoles={this.props.userRoles}
                    onChangeSelect={(indexes) => this.onRowSelectionChanged(indexes.map((index) => optionRows[index]))}
                    columns={optionColums}
                    loadedPSL={loadedPSL}
                    exportExcel={exportExcel}
                    setExportExcelFlags={this.setExportExcelFlags}
                    postOptions={postOptions}
                    derivates={this.state.derivates}
                    data={optionRows}
                    derivateToColorMap={derivateToColorMap}
                    readonly={!inEditMode || !updatable}
                    updatable={!updatable}
                    inEditMode={inEditMode}
                    createIOspecificOption={this.createIOspecificOption}
                    specificTypeOptionFilter={specificTypeOptionFilter}
                    assignmentTypeFilterValue={assignmentTypeFilter}
                    onOptionWFReset={this.onOptionWFReset}
                    isSpecificMarket={isSpecificMarketLoaded ? isSpecificMarketLoaded : false}
                    onCellClick={(key: string, index: number, data: TDataValue, visibleDerivates?: string[]) => {
                        let payload: any = _.set({}, "objectId", optionRows[index].objectId);
                        if (key === EColumnKey.DerivateKey) {
                            payload = _.set(payload, key, data);
                            payload = _.set(payload, "dto", optionRows[index].value);
                        } else if (key === EColumnKey.ConstraintKey || key === EColumnKey.ExclusionKey || EColumnKey.PackageContentKey) {
                            payload = _.set(payload, key, data);
                        } else {
                            // case not handled
                            return;
                        }

                        this.onCellClick(key, payload, visibleDerivates);
                    }
                    }
                    onApprove={this.onApprove}
                    onChange={(key: string, data: TDataValue, index: number) => {
                        // @refactored
                        let payload: any = {
                            objectId: optionRows[index].objectId
                        };
                        if (key === "statusView") {
                            key = "statusValueState";
                            payload = {...payload, statusValueState: (data as any).statusValueState};
                        } else if (key === OptionIndicatorsKey) {
                            return this.onTakeOverIndicator(key, data);
                        } else if (key === "availableStart" || key === "availableEnd") {
                            // @refactored
                            payload = {...payload, [key]: data};
                        } else if (key === EColumnKey.FlagKey) {
                            const flagDtos = this.props.flags.elements;
                            payload = {
                                ...payload,
                                // @ts-ignore at this point, the flags will exist
                                [key]: flagDtos.filter(flag => (data as number[]).includes(flag.objectId))
                            };
                        } else {
                            // @refactored
                            payload = {...payload, [key]: data};
                        }

                        this.onChangeCell(key, [payload]);
                    }}
                    onChangeWorkflow={this.onChangeOptionWorkflowTrigger}
                    flags={this.props.flags.elements}
                    selectedLanguages={selectedLanguageList || []}
                    languageList={this.state.languageList}
                    userLanguage={this.props.userLanguage}
                    page={this.state.page}
                    pageSize={this.state.pageSize}
                    totalElements={this.state.totalElements}
                    onPageChange={this.onPageChange}
                    isLoadingData={this.state.isLoadingData}
                    onLazyLoad={this.onLazyLoad}
                    onGridReadyParent={this.onGridReadyParent}
                    onNewFilterChange={this.onNewFilterChange}
                    newDropDownFilters={this.state.newDropDownFilters}
                    records={this.state.loadedRows.size}
                    filterCount={this.state.filterCount}
                    newGridFilters={this.state.newGridFilters}
                    onFilterByComparingAssignmentsChange={this.onFilterByComparingAssignmentsChange}
                    onFilterPccdSyncDataChange={this.onFilterPccdSyncDataChange}
                    onSelectionChanged={this.onAgGridSelectionChanged}
                    generationsRows={this.state.generationsRows}
                />
            </div>
        );
    }
    private updateAgGridRowByObjectId(objectId: number, updateCallback: (rowData: any) => void): void {
        if (this.state.agGridRef && this.state.agGridRef.api) {
            this.state.agGridRef.api.forEachNode((node: any) => {
                if (node.data && node.data.objectId === objectId) {
                    updateCallback(node.data);
                }
            });
        }
    }
    /** Reset the workflow for an option */
    private onOptionWFReset = (index: number) => {
        const {t, client} = this.props;
        let optionRows = _.cloneDeep(this.state.optionRows.slice());
        const opVal = optionRows[index];

        this.setModifiing(t("RESET_OPTION_WORKFLOW", {option: opVal.optionBasicView}));

        const resetRequest = client.PATCH_optionReset(opVal.dto);
        if (resetRequest.canExecute()) {
            resetRequest.execute(opVal.dto)
                .then((link: Link) => {
                    // request the updated object from database
                    return client.GET_optionSelf(link).execute();
                })
                .then((dto: OptionDto) => {
                    // replace the object with updated one
                    const newOpVal = new DataAdapterOptionsView(
                        dto,
                        opVal.derivates,
                        opVal.derivatesMap,
                        opVal.workflows,
                        opVal.languages,
                        opVal.cnrs
                    );
                    // set the real new value from database
                    optionRows[index] = newOpVal;
                    if (this.state.isNewGridTable) {
                        this.updateAgGridRowByObjectId(newOpVal.objectId, (rowData) => {
                            rowData.statusView = this.buildStatusView(
                                newOpVal,
                                this.isSpecificMarket() || false,
                                newOpVal.cnr !== undefined && newOpVal.cnr.cnr !== PropertiesKey.BasicMarketCnrKey
                            );
                        });
                    }

                    this.setState({optionRows});
                    this.props.DynTableSetSelectedIdList([]);

                    this.setModifiing();
                })
                .catch((error) => {
                    renderErrorToast({
                        message: "ERRORS:RESET_WORKFLOW",
                        details: error,
                        timestamp: Date.now()
                    });
                    this.setModifiing();
                });
        } else {
            renderErrorToast({
                message: "ERRORS:RESET_WORKFLOW",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            this.setModifiing();
        }
    }

    /** */
    private createIOspecificOption(key: string, index: number) {
        const {t} = this.props;
        const loadingMsg = t("CREATE_IO_SPECIFIC_OPTION");
        this.setModifiing(loadingMsg);

        let optionRows = _.cloneDeep(this.state.optionRows.slice());
        const daVal = optionRows[index];

        const {baseLinks, client} = this.props;
        const requestParam = this.state.optionRows[index].dto;
        const request = client.PATCH_specificIndependentOption(requestParam);
        const canCreateIOspecific = baseLinks && request && request.canExecute();

        if (canCreateIOspecific) {
            request.execute()
                .then((link: Link) => {
                    // request the updated object from database
                    return client.GET_optionSelf(link).execute();
                })
                .then((dto: OptionDto) => {
                    // replace the object with updated one
                    const ndto = new DataAdapterOptionsView(
                        dto,
                        daVal.derivates,
                        daVal.derivatesMap,
                        daVal.workflows,
                        daVal.languages,
                        daVal.cnrs
                    );
                    // set the real new value from database
                    optionRows[index] = ndto;

                    this.setState({optionRows});
                    this.setModifiing();
                })
                .catch((error) => {
                    renderErrorToast({
                        message: "ERRORS:CREATE_IO_OPTION_ERROR",
                        details: error,
                        timestamp: Date.now()
                    });
                    this.setModifiing();
                });

        } else {
            renderErrorToast({
                message: "ERRORS:CREATE_IO_OPTION_ERROR",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            this.setModifiing();
        }
    }

    /**
     * action for cell click on constraint, exclusion or derivate assignment(for complex components)
     */
    private onCellClick = (cellKey: string, value: DataAdapterOptionsView, visibleDerivates?: string[]) => {

        if (visibleDerivates && visibleDerivates.length > 0) {
            const editItem: TTableEditItem = {
                cellKey: cellKey,
                value: value,
                visibleDerivates: visibleDerivates
            };

            this.onMTBAssignmentsClick(editItem);

        } else {
            const editItem: TTableEditItem = {
                cellKey: cellKey,
                value: value
            };

            this.setState({
                isShowEditMultiselectItemDialog: true,
                editItem: editItem
            });
        }
    }

    private onMTBAssignmentsClick(editItem: TTableEditItem): void {
        const {client, t} = this.props;

        this.setModifiing(t("GET_MTBA_CONFLICTS"));

        const canUpdate = client.GET_optionUpdateAssignmentsConflicts(editItem.value.dto).canExecute()
            && client.PATCH_optionModeltypeAssignments(editItem.value.dto).canExecute();

        if (!canUpdate) {
            this.setModifiing(undefined);
            renderErrorToast({
                message: "ERRORS:GET_MTBA_CONFLICTS",
                timestamp: Date.now()
            });
            return;
        }

        const requestMTBAConflicts = client.GET_optionUpdateAssignmentsConflicts(editItem.value.dto);

        const params: PdipAssignedDerivatesParams = {
            optionId: editItem.value.objectId,
            modelYearId: editItem.value.dto.optionBasic.modelyear.objectId
        };

        if (this.state.postOptions) {
            const getPdipAssginedDerivates = client.GET_pdipAssignedDerivates(this.state.postOptions);
            Promise.all([requestMTBAConflicts.execute(), getPdipAssginedDerivates.execute(params)])
                .then((response: [any, AssignedModeltypeBasicDto[]]) => {
                    const [value, rpdipDerivates] = response;
                    this.setState({optionMTBAConflicts: value, editItem: editItem, isShowEditMTBAItemDialog: true, pdipDerivates: rpdipDerivates});
                })
                .catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:GET_MTBA_CONFLICTS",
                        details: reason,
                        timestamp: Date.now()
                    });
                    this.setModifiing();
                });
        }
    }

    /** Update data changed in an outside component. The rendering of new data is done only if no error appears. */
    private onChangeCellBeforeRender(cellKey: string, value: DataAdapterOptionsView): void {
        const {t} = this.props;
        if (this.state.optionRows !== null) {
            let optionRows = _.cloneDeep(this.state.optionRows.slice());
            const index = _.findIndex(optionRows, (val: DataAdapterOptionsView) => val.objectId === value.objectId);
            if (index >= 0) {
                // use data adapter for work on object
                const daVal = optionRows[index];
                const changingValue = daVal.value;
                let optionRowToUpdate = new DataAdapterOptionsView(
                    changingValue,
                    daVal.derivates,
                    daVal.derivatesMap,
                    daVal.workflows,
                    daVal.languages,
                    daVal.cnrs
                ); // use data adapter!
                if (optionRowToUpdate[cellKey] !== value[cellKey]) // check if the value changed
                {
                    optionRowToUpdate[cellKey] = value[cellKey];

                    // update PATCH_option, if OK, read the value again
                    const realValue = optionRowToUpdate.value;
                    // prepare error message
                    const params =
                    {
                        option: ColumnFactory.option2str(realValue)
                    };
                    let errMsg = "ERRORS:UPDATE_OPTION";

                    // different endpoints based on the updated field
                    let updateRequest: any;
                    if (cellKey === EColumnKey.DerivateKey) {
                        updateRequest = this.props.client.PATCH_optionModeltypeAssignments(realValue);
                    } else if (cellKey === EColumnKey.PackageContentKey) {
                        updateRequest = this.props.client.PATCH_optionPackage(realValue);
                    } else if (cellKey === EColumnKey.ConstraintKey) {
                        updateRequest = this.props.client.PATCH_optionConstraint(realValue);
                    } else if (cellKey === EColumnKey.ExclusionKey) {
                        updateRequest = this.props.client.PATCH_optionExclusion(realValue);
                    }

                    if (updateRequest === undefined || !updateRequest.canExecute()) {
                        renderErrorToast({
                            message: errMsg,
                            translationOptions: params,
                            details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                            timestamp: Date.now()
                        });
                        return;
                    } else {
                        // reset the filter
                        if (this.props.hideEmptyAssignmentsRowsAndColumns) {
                            this.props.SetHideEmptyAssignmentsRowsAndColumns(false);
                        }

                        const updating = t("UPDATE_OPTION", params);
                        this.setModifiing(updating);

                        updateRequest.execute(realValue)
                            .then((link: Link) => {
                                // request the updated object from data base
                                return this.props.client.GET_optionSelf(link).execute();
                            })
                            .then((dto: OptionDto) => {
                                // replace the object with updated one
                                const ndto = new DataAdapterOptionsView(
                                    dto,
                                    daVal.derivates,
                                    daVal.derivatesMap,
                                    daVal.workflows,
                                    daVal.languages,
                                    daVal.cnrs
                                );
                                optionRows[index] = ndto; // set the real new value from data base
                                if (this.state.isNewGridTable) {
                                    this.updateAgGridRowByObjectId(ndto.objectId, (rowData) => {
                                        rowData.derivateStates = ndto.derivateStates;
                                    });
                                }
                                this.setState({optionRows});
                                this.props.DynTableSetSelectedIdList([]);

                                this.setModifiing();
                            })
                            .catch((reason: any) => {
                                renderErrorToast({
                                    message: errMsg,
                                    translationOptions: params,
                                    details: reason,
                                    timestamp: Date.now()
                                });
                                this.setModifiing();
                            });
                    }
                }
            }

        }
    }

    /**
     * displays dialog for changing modeltype basic assignments
     */
    private showMTBAItemEditDialog() {
        this.setModifiing(undefined);

        const {
            isShowEditMTBAItemDialog,
            editItem,
            optionRows,
            derivates,
            optionMTBAConflicts,
            loadedPSL
        } = this.state;

        const {userLanguage} = this.props;

        if (!isShowEditMTBAItemDialog || !editItem || !editItem.visibleDerivates || !optionMTBAConflicts || !loadedPSL) {
            return;
        }

        const visibleDerivates = derivates.filter((der: ModeltypeBasicDto) =>
            editItem.visibleDerivates &&
            editItem.visibleDerivates.find((derName: string) => derName === DataAdapterOptionsView.createDerivateName(der, userLanguage))
        );

        const editRow = optionRows.find((optionRow) => optionRow.objectId === editItem.value.objectId);

        return (
            <ModeltypeBasicAssignmentsDialog
                title={this.props.t("EDIT_" + editItem.cellKey.toUpperCase() + "_TITLE")}
                dialogText={this.props.t("EDIT_" + editItem.cellKey.toUpperCase() + "_TEXT", {option: editItem.value.dto.optionBasicView})}
                isDraftAssignmentsOnly={editRow ? editRow.statusView !== WorkflowStatusDtoType.MAINTENANCE : false}
                typefamily={loadedPSL.typefamily}
                modelyear={editItem.value.dto.optionBasic.modelyear}
                unavailableDerivates={optionMTBAConflicts}
                derivates={visibleDerivates}
                derivatesMap={DataAdapterOptionsView.createIdToDerivateMap(visibleDerivates, userLanguage)}
                existingAssignments={editItem.value.derivateStates}
                onConfirm={this.confirmMTBAssignmentsUpdate}
                onCancel={this.cancelMTBAssignmentsUpdate}
                workflowStatus={editRow && editRow.statusView}
                pdipDerivates={this.state.pdipDerivates || []}
            />
        );
    }

    /** handle confirm action for option assignments update */
    private confirmMTBAssignmentsUpdate = (newValue: DataAdapterOptionsView) => {
        const editItem = this.state.editItem;
        if (editItem) {
            let payload: any = _.set({}, EColumnKey.ObjectIDKey, editItem.value.objectId);
            payload = _.set(payload, editItem.cellKey, newValue);

            this.setState(
                {
                    isShowEditMTBAItemDialog: false,
                    editItem: undefined,
                    optionMTBAConflicts: undefined
                },
                () => this.onChangeCellBeforeRender(editItem.cellKey, payload)
            );
        }
    }

    /** cancel action for option assignments update */
    private cancelMTBAssignmentsUpdate = () => {
        this.setState({
            isShowEditMTBAItemDialog: false,
            editItem: undefined,
            optionMTBAConflicts: undefined
        });
    }

    /**
     * displays dialog with multi select dropdown for editing constraint or exclusion values
     */
    private showMultiselectItemEditDialog() {
        const {isShowEditMultiselectItemDialog, editItem, optionRows} = this.state;

        if (!isShowEditMultiselectItemDialog || !editItem) {
            return;
        }

        const index = _.findIndex(optionRows, (val: DataAdapterOptionsView) => val.objectId === editItem.value.objectId);
        const optionCode = optionRows[index].optionBasicView;
        const optionBasicId = optionRows[index].optionBasic.objectId;

        // prepare data for multi select dropdown
        const value: ISelectFieldValue = {
            value: editItem.value[editItem.cellKey] && editItem.value[editItem.cellKey].length > 0 ?
                editItem.value[editItem.cellKey].map((ob: OptionBasicCoreDto) => ob.objectId) : [],
            options: this.state.baseOptions && this.state.baseOptions.length > 0 ?
                this.state.baseOptions.filter((ob: OptionBasicDto) => ob.objectId !== optionBasicId).map((item: OptionBasicDto) => {
                    const obItem: DropdownItemProps = {
                        value: item.objectId,
                        key: item.objectId,
                        text: item.optionCode ?
                            item.optionCode + '-' + item.optionType :
                            '<' + item.objectId + '>' + '-' + item.optionType
                    };
                    return obItem;
                }) : []
        };

        return (
            <MultiSelectDialog
                open={isShowEditMultiselectItemDialog}
                title={this.props.t("EDIT_" + editItem.cellKey.toUpperCase() + "_TITLE")}
                dialogText={this.props.t("EDIT_" + editItem.cellKey.toUpperCase() + "_TEXT", {option: optionCode})}
                cellKey={editItem.cellKey}
                value={value}
                onChange={(newValue: number[]) => {
                    let newData: OptionBasicCoreDto[] = [];
                    if (newValue && newValue.length > 0) {
                        this.state.baseOptions.forEach((ob: OptionBasicDto) => {
                            if (newValue.findIndex((id: number) => id === ob.objectId) !== -1) {
                                newData.push({
                                    objectId: ob.objectId,
                                    optionCode: ob.optionCode,
                                    optionType: OptionBasicCoreDtoOptionType[ob.optionType]
                                } as OptionBasicCoreDto);
                            }
                        });
                    }
                    let payload: any = _.set({}, "objectId", editItem.value.objectId);
                    payload = _.set(payload, editItem.cellKey, newData);

                    this.setState({isShowEditMultiselectItemDialog: false, editItem: undefined}, () => {
                        this.onChangeCellBeforeRender(editItem.cellKey, payload);
                    });
                }
                }
                onClose={() => this.setState({isShowEditMultiselectItemDialog: false, editItem: undefined})}
            />
        );
    }

    private onChangeCell(cellKey: string, values: Array<DataAdapterOptionsView>): void {
        const {t} = this.props;
        if (this.state.optionRows !== null) {
            let optionRows = this.state.optionRows.slice();
            values.forEach((value: DataAdapterOptionsView) => {
                const index = optionRows.findIndex((val: DataAdapterOptionsView) => val.objectId === value.objectId);
                if (index >= 0) {
                    // use data adapter for work on object
                    const daVal = optionRows[index];
                    const changingValue = daVal.value;
                    const prevValue = ColumnFactory.deepCopy(changingValue);
                    let optionRowToUpdate = new DataAdapterOptionsView(
                        changingValue,
                        daVal.derivates,
                        daVal.derivatesMap,
                        daVal.workflows,
                        daVal.languages,
                        daVal.cnrs
                    ); // use data adapter!
                    // check if the value changed
                    if (optionRowToUpdate[cellKey] !== value[cellKey]) {
                        optionRowToUpdate[cellKey] = value[cellKey];

                        // update PATCH_option, if OK, read the value again
                        let realValue = optionRowToUpdate.value;
                        // prepare error message
                        const params =
                        {
                            option: ColumnFactory.option2str(realValue)
                        };
                        let errMsg = "ERRORS:UPDATE_OPTION";
                        let tParams = params;

                        // different endpoints based on the updated field
                        let updateRequest: any;
                        let requestParams: any;
                        if (cellKey === EColumnKey.ShorttextKey || cellKey === EColumnKey.LongtextKey || cellKey === EColumnKey.FooterKey || cellKey === EColumnKey.UspKey) {
                            updateRequest = this.props.client.PATCH_optionTexts(realValue);
                            requestParams = realValue;
                        } else if (cellKey === EColumnKey.FlagKey) {
                            updateRequest = this.props.client.PATCH_optionFlag(realValue);
                            requestParams = realValue;
                        }

                        else {
                            requestParams = {
                                option: realValue,
                                updatedColumn: cellKey
                            };

                            updateRequest = this.props.client.PATCH_option(realValue);
                        }

                        if (!updateRequest.canExecute()) {
                            optionRows[index] = new DataAdapterOptionsView(
                                prevValue,
                                daVal.derivates,
                                daVal.derivatesMap,
                                daVal.workflows,
                                daVal.languages,
                                daVal.cnrs
                            ); // restore the old value
                            this.setState({optionRows});
                            renderErrorToast({
                                message: errMsg,
                                translationOptions: tParams,
                                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                                timestamp: Date.now()
                            });
                            this.props.DynTableRollBack(true);
                        } else {
                            const updating = t("UPDATE_OPTION", params);
                            this.setModifiing(updating);

                            updateRequest.execute(requestParams)
                                .then((link: Link) => {
                                    // request the updated object from data base
                                    return this.props.client.GET_optionSelf(link).execute();
                                })
                                .then((dto: OptionDto) => {
                                    // replace the object with updated one
                                    const ndto = new DataAdapterOptionsView(
                                        dto,
                                        daVal.derivates,
                                        daVal.derivatesMap,
                                        daVal.workflows,
                                        daVal.languages,
                                        daVal.cnrs
                                    );
                                    optionRows[index] = ndto; // set the real new value from data base
                                    optionRows = sortOptions(optionRows, this.props.optionTableSort);
                                    this.setState({optionRows});
                                    if (this.state.isNewGridTable) {
                                        this.updateAgGridRowByObjectId(ndto.objectId, (rowData) => {
                                            if (cellKey === 'statusValueState') {
                                                rowData.statusView = this.buildStatusView(
                                                    ndto,
                                                    this.isSpecificMarket() || false,
                                                    ndto.cnr !== undefined && ndto.cnr.cnr !== PropertiesKey.BasicMarketCnrKey
                                                );
                                            } else {
                                                const tempRowData = this.buildData([ndto]);
                                                const updatedRow = tempRowData[0][0];
                                                rowData[cellKey] = updatedRow[cellKey];
                                            }
                                        });
                                    }
                                    this.props.DynTableSetSelectedIdList([]);

                                    this.setModifiing();
                                })
                                .catch((reason: any) => {
                                    optionRows[index] = new DataAdapterOptionsView(
                                        prevValue,
                                        daVal.derivates,
                                        daVal.derivatesMap,
                                        daVal.workflows,
                                        daVal.languages,
                                        daVal.cnrs
                                    ); // restore the old value
                                    this.setState({optionRows});
                                    renderErrorToast({
                                        message: errMsg,
                                        translationOptions: tParams,
                                        details: reason,
                                        timestamp: Date.now()
                                    });
                                    this.setModifiing();
                                    this.props.DynTableRollBack(true);
                                });
                        }
                    }
                }
            }
            );
        }
    }

    private onTakeOverIndicator(cellKey: string, newValue: any): void {
        const {t} = this.props;
        if (this.state.optionRows !== null) {

            let optionRows = this.state.optionRows.slice();
            const index = optionRows.findIndex((val: DataAdapterOptionsView) => val.objectId === newValue.objectId);
            if (index >= 0) {
                // use data adapter for work on object
                const daVal = optionRows[index];
                const changingValue = daVal.value;
                const prevValue = ColumnFactory.deepCopy(changingValue);

                let errMsg = "ERRORS:UPDATE_OPTION";

                // different endpoints based on the updated field
                const updateRequest = this.props.client.PATCH_optionTexts(daVal.value);

                changingValue.texts = newValue.dto.texts;

                const requestParams = changingValue;

                if (!updateRequest.canExecute()) {
                    optionRows[index] = new DataAdapterOptionsView(
                        prevValue,
                        daVal.derivates,
                        daVal.derivatesMap,
                        daVal.workflows,
                        daVal.languages,
                        daVal.cnrs
                    ); // restore the old value
                    this.setState({optionRows});
                    renderErrorToast({
                        message: errMsg,
                        details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                        timestamp: Date.now()
                    });
                    this.props.DynTableRollBack(true);
                } else {
                    const updating = t("UPDATE_OPTION");
                    this.setModifiing(updating);

                    updateRequest.execute(requestParams)
                        .then((link: Link) => {
                            // request the updated object from data base
                            return this.props.client.GET_optionSelf(link).execute();
                        })
                        .then((dto: OptionDto) => {
                            // replace the object with updated one
                            const ndto = new DataAdapterOptionsView(
                                dto,
                                daVal.derivates,
                                daVal.derivatesMap,
                                daVal.workflows,
                                daVal.languages,
                                daVal.cnrs
                            );
                            optionRows[index] = ndto; // set the real new value from data base
                            optionRows = sortOptions(optionRows, this.props.optionTableSort);
                            if (this.state.isNewGridTable) {
                                this.updateAgGridRowByObjectId(ndto.objectId, (rowData) => {
                                    rowData.optionIndicators = ndto.optionIndicators;
                                });
                            }
                            this.setState({optionRows});
                            this.props.DynTableSetSelectedIdList([]);

                            this.setModifiing();
                        })
                        .catch((reason: any) => {
                            optionRows[index] = new DataAdapterOptionsView(
                                prevValue,
                                daVal.derivates,
                                daVal.derivatesMap,
                                daVal.workflows,
                                daVal.languages,
                                daVal.cnrs
                            ); // restore the old value
                            this.setState({optionRows});
                            renderErrorToast({
                                message: errMsg,
                                details: reason,
                                timestamp: Date.now()
                            });
                            this.setModifiing();
                            this.props.DynTableRollBack(true);
                        });
                }
            }
        }
    }

    /**
     * Sets the flag for showing the dialog for changing an option's workflow
     * and sets the param with necessary data
     *
     * @param key
     *      the column key for workflow
     * @param objectId
     *      the object id of the option that has to be updated
     * @param index
     *      the option's index(row) in the table data
     */
    private onChangeOptionWorkflowTrigger = (key: string, objectId: number, index: number) => {
        const loadingMsg = this.props.t("OPTIONS_VIEW:GET_OPTION_WORKFLOWS");
        this.props.AddLoadingMessage(loadingMsg);

        let optionRows = this.state.optionRows.slice();
        const optionDAW = optionRows[index];
        const optionDto = optionDAW.dto;
        if (optionDto.objectId !== objectId) {
            renderErrorToast({
                message: "OPTIONS_VIEW:WRONG_CHANGE_WF_DATA",
                timestamp: Date.now()
            });
            this.props.RemoveLoadingMessage(loadingMsg);
            return;
        }

        // check rights
        const requestWorkflows = this.props.client.GET_validOptionWorkflows(optionDto);
        if (requestWorkflows.canExecute()) {

            // request available workflows
            const optionBasicId = optionDto.optionBasic.objectId;
            let getWorkflowsParam: GetWorkflowOptionParams = {
                typeFamily: optionDto.typefamilyId,
                optionBasicDtoIds: [optionBasicId],
            };

            requestWorkflows.execute(getWorkflowsParam)
                .then((response: {[key: number]: WorkflowDto[]}) => {
                    const changeOptionWorkflowParam: PSLChangeWorkflowParam = {
                        cellKey: key,
                        value: optionDAW,
                        workflows: response[optionBasicId]
                    };

                    this.setState({
                        showChangeOptionWorkflowDlg: true,
                        changeOptionWorkflowParam: changeOptionWorkflowParam
                    });

                    this.props.RemoveLoadingMessage(loadingMsg);
                }).catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:GET_WORKFLOWS",
                        details: reason,
                        timestamp: Date.now()
                    });
                    this.props.RemoveLoadingMessage(loadingMsg);
                });
        } else {
            renderErrorToast({
                message: "MISSING_ACCESS_RIGHTS",
                details: "ERRORS:GET_WORKFLOWS",
                timestamp: Date.now()
            });
            this.props.RemoveLoadingMessage(loadingMsg);
        }
    }

    /**
     * Return dialog for changing an option's workflow
     */
    private renderChangeOptionWorkflowDlg = (): JSX.Element | null => {
        if (this.state.showChangeOptionWorkflowDlg && this.state.changeOptionWorkflowParam !== undefined) {
            return (
                <ChangeWorkflowOptionDlg
                    changeOptionWorkflowParam={this.state.changeOptionWorkflowParam}
                    onSave={this.handleChangeOptionWorkflow}
                    onClose={this.closeChangeOptionWorkflowDlg}
                />
            );
        }

        return null;
    }

    /**
     * Update the option with the new status
     *
     * @param newStatus
     *      new workflow status for the option
     *      (composed of {wokflowId}_{firstStepId})
     */
    private handleChangeOptionWorkflow = (newStatus: string) => {
        if (this.state.changeOptionWorkflowParam) {
            // get the option dto
            let dto = {... this.state.changeOptionWorkflowParam.value.dto};

            // loading message
            const tParams = {option: ColumnFactory.option2str(dto)};
            const updatingMsg = this.props.t("UPDATE_OPTION", tParams);
            this.props.AddLoadingMessage(updatingMsg);

            // check rights
            if (this.props.client.PATCH_option(dto).canExecute()) {

                // update status value
                dto.status = newStatus;

                const requestParams: OptionUpdateDto = {
                    option: dto,
                    updatedColumn: this.state.changeOptionWorkflowParam.cellKey
                };
                const updateRequest = this.props.client.PATCH_option(dto);
                updateRequest.execute(requestParams)
                    .then((link: Link) => {
                        // request the updated object from data base
                        return this.props.client.GET_optionSelf(link).execute();
                    })
                    .then((updatedDto: OptionDto) => {

                        // @ts-ignore warning because it's already checked in the first line
                        let daVal = {... this.state.changeOptionWorkflowParam.value};
                        // replace the object with updated one
                        const ndto = new DataAdapterOptionsView(
                            updatedDto,
                            daVal.derivates,
                            daVal.derivatesMap,
                            daVal.workflows,
                            daVal.languages,
                            daVal.cnrs
                        );

                        // set the real new value from data base
                        let optionRows = this.state.optionRows.slice();
                        const index = optionRows.findIndex((val: DataAdapterOptionsView) => val.objectId === updatedDto.objectId);
                        optionRows[index] = ndto;
                        optionRows = sortOptions(optionRows, this.props.optionTableSort);
                        if (this.state.isNewGridTable) {
                            this.updateAgGridRowByObjectId(updatedDto.objectId, (rowData) => {
                                rowData.statusView = this.buildStatusView(
                                    ndto,
                                    this.isSpecificMarket() || false,
                                    ndto.cnr !== undefined && ndto.cnr.cnr !== PropertiesKey.BasicMarketCnrKey
                                );
                            });
                        }

                        // update state
                        this.setState({
                            optionRows: optionRows,
                            showChangeOptionWorkflowDlg: false,
                            changeOptionWorkflowParam: undefined
                        });

                        this.props.DynTableSetSelectedIdList([]);
                        this.props.RemoveLoadingMessage(updatingMsg);
                    })
                    .catch((reason: any) => {
                        renderErrorToast({
                            message: "ERRORS:UPDATE_OPTION",
                            translationOptions: tParams,
                            details: reason,
                            timestamp: Date.now()
                        });

                        this.closeChangeOptionWorkflowDlg();
                        this.props.RemoveLoadingMessage(updatingMsg);
                    });
            } else {
                renderErrorToast({
                    message: "MISSING_ACCESS_RIGHTS",
                    details: "ERRORS:UPDATE_OPTION",
                    timestamp: Date.now()
                });

                this.closeChangeOptionWorkflowDlg();
                this.props.RemoveLoadingMessage(updatingMsg);
            }
        }
    }

    /**
     * Closes the dialog for changing an option's workflow
     * and clears the state variable with necessary data
     */
    private closeChangeOptionWorkflowDlg = () => {
        this.setState({
            showChangeOptionWorkflowDlg: false,
            changeOptionWorkflowParam: undefined
        });
    }

    private onApprove = (approval: IPSLApproval, index: number) => {
        const {t, client, optionTableSort} = this.props;
        if (this.state.optionRows !== null) {
            let optionRows = this.state.optionRows.slice();
            const daVal = optionRows[index];
            if (daVal) {
                const optionDto = daVal.value;
                const errMsg = "ERRORS:UPDATE_OPTION";
                const tParams = {option: ColumnFactory.option2str(optionDto)};

                if (this.state.postOptions === undefined
                    || !client.POST_approvals(this.state.postOptions as ResourceListOfWorkflowOptionApprovalDto).canExecute()) {
                    renderErrorToast({
                        message: errMsg,
                        translationOptions: tParams,
                        details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                        timestamp: Date.now()
                    });
                } else {
                    const updateWorkflowRequest = client.POST_approvals(this.state.postOptions as ResourceListOfWorkflowOptionApprovalDto);

                    // maps the option to create a WorkflowOptionApprovalDto
                    // by using dummy data for unnecessary fields
                    // @ts-ignore
                    const approvalOptionDto: WorkflowOptionApprovalDto = {
                        approved: approval.approved,
                        rejectMessage: approval.rejectMessage,
                        modelyear: optionDto.optionBasic.modelyear,
                        optionVersion: optionDto.versionId,
                        optionCode: daVal.optionBasicView,
                        optionType: daVal.optionTypeView,
                        optionId: optionDto.objectId,
                        typefamily: {
                            objectId: optionDto.typefamilyId
                        },
                        cnr: {
                            objectId: optionDto.cnrId,
                        },
                        currentWorkflowStatus: {},
                        nextWorkflowStatus: {},
                        requestingRole: {},
                        importer: {},
                        workflow: {},
                        versionId: 0,
                        objectId: 0,
                    };
                    const updating = t("UPDATE_OPTION", tParams);
                    this.setModifiing(updating);

                    updateWorkflowRequest.execute([approvalOptionDto])
                        .then(() => {
                            // request the updated object from data base
                            return client.GET_optionSelfLinks(optionDto).execute();
                        })
                        .then((dto: OptionDto) => {
                            // replace the object with updated one
                            const ndto = new DataAdapterOptionsView(
                                dto,
                                daVal.derivates,
                                daVal.derivatesMap,
                                daVal.workflows,
                                daVal.languages,
                                daVal.cnrs
                            );
                            optionRows[index] = ndto; // set the real new value from data base
                            optionRows = sortOptions(optionRows, optionTableSort);
                            if (this.state.isNewGridTable) {
                                this.updateAgGridRowByObjectId(ndto.objectId, (rowData) => {
                                    rowData.statusView = this.buildStatusView(
                                        ndto,
                                        this.isSpecificMarket() || false,
                                        ndto.cnr !== undefined && ndto.cnr.cnr !== PropertiesKey.BasicMarketCnrKey
                                    );
                                });
                            }
                            this.setState({optionRows});
                            this.props.DynTableSetSelectedIdList([]);

                            this.setModifiing();
                        })
                        .catch((reason: any) => {
                            renderErrorToast({
                                message: errMsg,
                                translationOptions: tParams,
                                details: reason,
                                timestamp: Date.now()
                            });
                            this.setModifiing();
                        });
                }
            }
        }
    }

    private toggleSetting(saveFunc: (settings: IOptionsViewUserSettings, value: boolean) => IOptionsViewUserSettings, value: boolean): void {
        const newSettings = saveFunc(this.props.userSettings.optionsView, value);
        this.props.ChangeOptionsViewUserSettings(newSettings);
    }

    private handleColumnSelectionChanged(column: SelectableColumn) {
        column.visible = !column.visible;
        this.setState(this.state);

        const settings = this.props.userSettings.optionsView;
        const newSettings = saveColumns(settings, this.state.optionColums);
        this.props.ChangeOptionsViewUserSettings(newSettings);
    }

    private onReorderColumns(columns: string[]) {
        let reorderedColumns = this.state.optionColums.slice().sort((lhs, rhs) => {
            const lhsIdx = columns.indexOf(lhs.key);
            const rhsIdx = columns.indexOf(rhs.key);
            return (lhsIdx === rhsIdx) ? 0 : (lhsIdx > rhsIdx ? 1 : -1);
        });
        if (reorderedColumns.length > 0 && reorderedColumns[0].key !== OptionBasicViewKey) {
            // ignore attempts to reorder the i-number column
            reorderedColumns = this.state.optionColums;
        }
        this.setState({optionColums: reorderedColumns});

        const settings = this.props.userSettings.optionsView;
        const newSettings = saveColumns(settings, reorderedColumns);
        this.props.ChangeOptionsViewUserSettings(newSettings);
    }

    private onChangeDerivateVisible(derivate: string, visible: boolean) {
        const settings = this.props.userSettings.optionsView;
        const {hiddenDerivates} = settings;
        let nh;
        if (!visible) {
            nh = [...hiddenDerivates];
            if (hiddenDerivates.findIndex(der => der === derivate) === -1) {
                nh.push(derivate);
            }
        } else {
            nh = hiddenDerivates.filter(der => der !== derivate);
        }

        const newSettings = saveDerivateVisibility(settings, nh);
        this.props.ChangeOptionsViewUserSettings(newSettings);
    }

    private excelDownload = (excelLink: ExcelExportResponseDto) => {
        downloadExcel(excelLink);
    }

    render() {
        const {
            isShowPSLSelectDialog,
            isShowEditMultiselectItemDialog,
            isShowEditMTBAItemDialog,
            isShowCopyOptionDialog,
            isShowHistoryDialog,
            pslCopyContexts,
            showPSLCopyDerivateDisclaimer,
            showPSLCopyCnrsStats,
            pslCopyCnrsStats,
            showPSLCopyConflicts,
            pslCopyConflicts,
            showPSLCopyResultSummary,
            pslCopyResultSummary,
            showTransferAssignmentsDlg,
            selectedItems,
            showChangeOptionWorkflowDlg,
            changeOptionWorkflowParam,
            showWorkflowStatusMultiUpdateDlg,
            showMultipleDeleteOptionDlg,
            showCheckPCCDSyncResultDlg,
            showUpdateDraftAssignments,
            showMultipleUpdateFlagDlg
        } = this.state;

        return (
            <ViewContainer className={"display--flex flex-direction--column"}>
                <ErrorBoundary>
                    {
                        this.renderHeader()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        isShowPSLSelectDialog &&
                        this.renderPslSelectionDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        !isShowPSLSelectDialog &&
                        this.renderOptions()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        isShowCopyOptionDialog &&
                        this.showOptionCopyDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        this.showDeleteConfirmDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        this.createSpecificOptionDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        isShowEditMultiselectItemDialog &&
                        this.showMultiselectItemEditDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        isShowEditMTBAItemDialog &&
                        this.showMTBAItemEditDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {this.state.showCompareDialog && this.state.selectedItem && <OptionDifferenceView
                        selectedOption={this.state.selectedItem}
                        onClose={() => this.setState({showCompareDialog: false})}
                    />}
                </ErrorBoundary>

                {/** PSL copy dialogs start */}
                <ErrorBoundary>
                    {
                        showPSLCopyDerivateDisclaimer && pslCopyContexts &&
                        this.renderPSLCopyDerivateDisclaimer()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        showPSLCopyCnrsStats && pslCopyCnrsStats &&
                        this.renderPSLCopyCnrsStats()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        showPSLCopyConflicts && pslCopyConflicts &&
                        this.renderPSLCopyConflicts()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        showPSLCopyResultSummary && pslCopyResultSummary &&
                        this.renderPSLCopyResultSummary()
                    }
                </ErrorBoundary>
                {/** PSL copy dialogs end */}

                <ErrorBoundary>
                    {
                        showTransferAssignmentsDlg && selectedItems.length > 0 &&
                        this.renderAMTBTransferDlg()
                    }
                </ErrorBoundary>

                <ErrorBoundary>
                    {
                        showChangeOptionWorkflowDlg && changeOptionWorkflowParam &&
                        this.renderChangeOptionWorkflowDlg()
                    }
                </ErrorBoundary>

                <ErrorBoundary>
                    {
                        showWorkflowStatusMultiUpdateDlg && selectedItems.length > 0 &&
                        this.renderWorkflowStatusMultiUpdateDlg()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        showMultipleUpdateFlagDlg && selectedItems.length > 0 &&
                        this.renderFlagMultiUpdateDlg()
                    }
                </ErrorBoundary>
                <ErrorBoundary>
                    {
                        showMultipleDeleteOptionDlg && selectedItems.length > 0 &&
                        this.renderMultipleOptionDeletionDlg()
                    }
                </ErrorBoundary>

                <ErrorBoundary>
                    {showCheckPCCDSyncResultDlg && this.renderCheckPCCDSyncResultDlg()}
                </ErrorBoundary>

                <ErrorBoundary>
                    {
                        showUpdateDraftAssignments && selectedItems.length > 0 &&
                        this.renderUpdateDraftAssignmentsDlg()
                    }
                </ErrorBoundary>
                <ErrorBoundary >
                    {isShowHistoryDialog && this.renderHistoryDlg()}
                </ErrorBoundary >
            </ViewContainer>

        );
    }

    private onCheckRowSelectable(value: DataAdapterOptionsView): boolean {
        const {postOptions} = this.state;
        const deleteable = this.props.client.DELETE_option(value.value).canExecute();
        return postOptions !== undefined || deleteable;
    }

    private onRowSelectionChanged(values: Array<DataAdapterOptionsView>) {

        this.setState({selectedItems: values});

        if (values.length === 1) {
            this.setState({selectedItem: values[0], isMultiselectActive: false});
        } else if (values.length > 1) {
            this.setState({selectedItem: undefined, isMultiselectActive: true});
        } else {
            this.setState({selectedItem: undefined, isMultiselectActive: false});
        }
    }
    private onAgGridSelectionChanged = () => {
        if (this.state.agGridRef && this.state.agGridRef.api) {
            const gridApi = this.state.agGridRef.api;
            const selectedNodes = gridApi.getSelectedNodes();
            const selectedData = selectedNodes.map((node: any) => node.data);
            // If single selection, get the first selected row
            const selectedRow = selectedData[0] || null;
            if (this.state.optionRows) {
                const selectedItem = this.state.optionRows.find(item => item.objectId === (selectedRow ? selectedRow.objectId : -1));
                this.setState({
                    selectedItem,
                    inEditMode: false,
                    selectedItems: selectedItem ? [selectedItem] : []
                });
            }
        }
    }

    private excelExport(filters: OptionFilterDto) {
        if (this.state.loadedPSL) {

            this.setState({excelIsGenerating: true});

            // Set initial filters for the curent psl
            const {modelyear} = this.state.loadedPSL;
            const typefamilyId = this.state.loadedPSL.typefamily.objectId;
            const cnrId = this.state.loadedPSL.cnr.objectId;
            const selectedLanguageList = this.state.selectedLanguageList;

            filters.typefamilyIdFilter = typefamilyId;
            filters.cnrIdFilter = cnrId;
            filters.modelyearIdFilter = modelyear.objectId;

            if (selectedLanguageList) {
                filters.selectedLanguages = selectedLanguageList.map(lang => lang.objectId);
            }

            // Make the request and post the option filters

            if (this.state.postOptions && this.props.client.POST_ExcelExport(this.state.postOptions).canExecute()) {
                this.props.client.POST_ExcelExport(this.state.postOptions).execute(filters).then(
                    (response: ExcelExportResponseDto) => {
                        toast.success(
                            (
                                <div className="excel-notification">
                                    <h1>{this.props.t('OPTIONS_VIEW:EXCEL_SUCCESS_HEADER')}</h1>
                                    <p>{this.props.t('OPTIONS_VIEW:EXCEL_SUCCESS_MESSAGE')}:</p>
                                    <a onClick={() => this.excelDownload(response)} download={true}>
                                        {response.fileName}
                                    </a>
                                </div>
                            )
                        );
                        this.setState({excelIsGenerating: false});
                    }
                ).catch(
                    (Response) => {
                        this.setState({excelIsGenerating: false});
                        renderErrorToast({
                            message: "ERRORS:EXCEL_GENERATE",
                            details: Response,
                            timestamp: Date.now()
                        });
                    }
                );
            } else {
                renderErrorToast({
                    message: "ERRORS:EXCEL_GENERATE",
                    details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
            }
        }
    }

    setExportExcelFlags = (areFlagsEnabled: boolean) => {
        this.setState({
            exportExcel: areFlagsEnabled,
            excelIsGeneratingV2: areFlagsEnabled
        });
    }
    private onShowMoreHistory = async (id: string) => {
        this.setState({isShowMoreHistory: true});
        const data = await this.props.client.getHistoryByWorkflowId(+id);
        this.setState({moreHistoryData: data});
    }
    private renderHistoryDlg = () => {
        const {t} = this.props;

        if (this.state.selectedItem) {
            const selectedItem = this.state.selectedItem;
            const modelYear = selectedItem.optionBasic.modelyear;
            const typeFamily = this.props.userTypefamiliesMap && this.props.userTypefamiliesMap[modelYear.mj1] && this.props.userTypefamiliesMap[modelYear.mj1].elements ?
                _.find(this.props.userTypefamiliesMap[modelYear.mj1].elements, item => item.objectId === selectedItem.dto.typefamilyId) : undefined;

            return (
                <HistoryDialog
                    identifier={`${t("GLOBAL:MODELYEAR")}: ${modelYear.mj1} (${modelYear.mj4}) -
                                ${t("GLOBAL:TYPEFAMILY")}: ${typeFamily ? typeFamily.name : ''} -
                                ${t("GLOBAL:CNR")}: ${selectedItem.cnr ? selectedItem.cnr.name : ''} -
                                ${t("COLUMN_FACTORY:OPTIONCODE")}: ${selectedItem.optionBasic.optionCode}`}
                    historyData={this.state.selectedItemFilteredHistoryData || []}
                    t={this.props.t}
                    userSettings={this.props.userSettings}
                    derivates={this.state.derivates}
                    dialogTitle={"OPTION_HISTORY_TT"}
                    onClose={() => this.setState({isShowHistoryDialog: false, selectedItemHistoryData: undefined})}
                    filterValues={this.state.fieldKeyFilters || new Set<string>()}
                    onChangeFilterValue={(fieldKey: string) => this.onChangeFilterValue(fieldKey)}
                    isShowMoreHistory={this.state.isShowMoreHistory}
                    onShowMoreHistory={(id: string) => this.onShowMoreHistory(id)}
                    onCloseMoreHistotyDialog={() => this.setState({isShowMoreHistory: false})}
                    moreHistoryData={this.state.moreHistoryData || []}
                />
            );
        } else {
            return undefined;
        }
    }

    private onChangeFilterValue = (selectedFieldKey: string | undefined) => {
        if (selectedFieldKey !== undefined && selectedFieldKey !== '') {
            this.setState({
                selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
                    && this.state.selectedItemHistoryData.filter(value => value.fieldKey === selectedFieldKey)
            });
        } else {
            this.setState({
                selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
            });
        }
    }

    private createDropdownFilterValues = () => {
        const fieldKeys: Set<string> = new Set<string>();

        if (this.state.selectedItemHistoryData) {
            fieldKeys.add("");
            this.state.selectedItemHistoryData.map(data => {
                if (data.fieldKey) {
                    fieldKeys.add(data.fieldKey);
                }
            });
        }

        this.setState({fieldKeyFilters: fieldKeys});
    }

    private requestBaseOptionHistory = () => {
        if (this.state.selectedItem) {
            const getHistoryRequest = this.props.client.GET_optionSelfHistory(this.state.selectedItem.dto);
            if (!getHistoryRequest.canExecute()) {
                renderErrorToast({
                    message: 'GLOBAL:MISSING_ACCESS_RIGHTS',
                    timestamp: Date.now()
                });
                return;
            }

            const params = {
                language: this.props.userLanguage
            };

            const requestLoadingMessage = this.props.t('BASEOPTIONS:GET_HISTORY');
            this.props.AddLoadingMessage(requestLoadingMessage);

            getHistoryRequest.execute(params)
                .then((returnValue: HistoryDto[]) => {
                    this.setState({
                        isShowHistoryDialog: true,
                        selectedItemHistoryData: returnValue,
                        selectedItemFilteredHistoryData: returnValue
                    });

                    this.props.RemoveLoadingMessage(requestLoadingMessage);
                    this.createDropdownFilterValues();
                }).catch((reason: any) => {
                    this.props.RemoveLoadingMessage(requestLoadingMessage);
                    renderErrorToast({
                        message: 'ERRORS:GET_HISTORY',
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }
    goToNextMatch = () => {
        const matches = Array.from(document.querySelectorAll('.active-match, [style*="background-color: yellow"], [style*="background: yellow"]'));
        if (matches.length === 0) return;
        let nextIndex = (this.state.currentMatchIndex + 1) % matches.length;
        this.setState({currentMatchIndex: nextIndex}, () => {
            this.scrollToMatch(nextIndex, matches);
        });
    }

    goToPrevMatch = () => {
        const matches = Array.from(document.querySelectorAll('[style*="background-color: yellow"], [style*="background: yellow"]'));
        if (matches.length === 0) return;
        let prevIndex = (this.state.currentMatchIndex - 1 + matches.length) % matches.length;
        this.setState({currentMatchIndex: prevIndex}, () => {
            this.scrollToMatch(prevIndex, matches);
        });
    }

    scrollToMatch = (idx: number, matches: any) => {
        matches.forEach((ele: any) => {
            ele.classList.remove('active-match');
            if (ele.childNodes.length > 0 && ele.lastChild.nodeType === 1) {
                (ele.lastChild as HTMLElement).classList.remove('active-match');
            }
        });
        const el = matches[idx];
        if (el) {
            if (el.childNodes.length > 0 && el.lastChild.nodeType === 1) {
                (el.lastChild as HTMLElement).classList.add('active-match');
                (el.lastChild as HTMLElement).scrollIntoView({behavior: 'smooth', block: 'center'});
            } else {
                el.classList.add('active-match');
                el.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        }
    }
    private isAnyFilterApplied = () => {
        const filters = this.state.newGridFilters;
        const arrayKeys = [
            "categoryFilters",
            "workflowFilters",
            "optionTypeFilters",
            "flags"
        ];
        for (const key in filters) {
            if (!filters.hasOwnProperty(key)) continue;
            const value = filters[key];
            // Special handling for hasAssignment and isGlobalSearch
            if (key === "hasAssignment" || key === "isGlobalSearch") {
                if (value === true || value === "true") return true;
                continue; // skip if false or "false"
            }
            if (arrayKeys.includes(key)) {
                if (Array.isArray(value) && value.length > 0) return true;
            } else if (value === null || value === undefined) {
                continue;
            } else if (typeof value === "string") {
                if (value.trim() !== "") return true;
            } else if (typeof value === "boolean") {
                if (value === true) return true;
            } else {
                if (value !== "") return true;
            }
        }
        return false;
    }
    private renderHeader() {
        const {
            inEditMode,
            deleteable,
            updatable,
            selectedItem,
            isMultiselectActive,
            optionRows,
            postOptions,
            selectedItems,
            excelIsGenerating,
            excelIsGeneratingV2,
            derivates,
            assignmentTypeFilter,
            specificTypeOptionFilter,
            loadedPSL,
            selectedLanguageList,
            languageList,
            isNewGridTable,
        } = this.state;
        const {t, client, switchHeaderMode} = this.props;
        const isSpecificMarketLoaded = this.isSpecificMarket();
        let disabledDelOrMulDelBtn;
        const hasMultiDelBtn = true;

        if (!isSpecificMarketLoaded && postOptions && deleteable && selectedItems.length > 0
            && client.DELETE_optionMultipleDelete(postOptions).canExecute()) {
            disabledDelOrMulDelBtn = inEditMode;
        } else {
            disabledDelOrMulDelBtn = inEditMode || selectedItem === undefined
                || !this.props.client.DELETE_option(selectedItem.value).canExecute() || isMultiselectActive ||
                // if a specific market PSL is loaded, disable delete button for options inherited from basic market
                this.isBasicMarketItemSelectedInSpecificPSL();
        }
        return (
            <OptionsHeader
                switchHeaderMode={switchHeaderMode}
                viewName={VIEWNAME.OPTIONVIEW}
                inEditMode={inEditMode}
                hasAsisigmantsAction={true}
                isSelected={selectedItems.length > 0}
                hasCopyButton={!isSpecificMarketLoaded && selectedItem !== undefined && client.POST_optionCopy(selectedItem.dto).canExecute()}
                hasMultipleDeleteButton={hasMultiDelBtn}
                hasEditButton={!isSpecificMarketLoaded && updatable}
                hasReloadButton={true}
                hasExportButton={!isSpecificMarketLoaded && optionRows.length > 0
                    && postOptions && client.POST_ExcelExport(postOptions).canExecute()}
                hasExcelExportButtonV2={optionRows.length > 0
                    && postOptions && client.POST_excelExportV2(postOptions).canExecute()}
                hasSpecificOptionButton={false}
                // TODO: adjust implementation when the requirments for new specific options are done
                hasCompareButton={false}
                hasTransferAssignmentsButton={!isSpecificMarketLoaded
                    && postOptions && client.PATCH_optionTranferAssignments(postOptions).canExecute()}
                hasWorkflowStatusMultiUpdateButton={!isSpecificMarketLoaded
                    && postOptions && client.PATCH_optionWorkflowStatusMultiUpdate(postOptions).canExecute()}
                hasCheckPCCDSyncronisationButton={!isSpecificMarketLoaded && optionRows.length > 0
                    && postOptions && client.GET_pslPCCDSynchronisation(postOptions).canExecute()}
                hasUpdateDraftAssignmentsButton={!isSpecificMarketLoaded && optionRows.length > 0
                    && postOptions && client.PATCH_optionDraftAssignments(postOptions).canExecute()}
                hasHistoryButton={true}
                hasSelectLanguageButton={isSpecificMarketLoaded}

                disabledCopyButton={inEditMode || isMultiselectActive}

                disabledMultipleDeleteButton={disabledDelOrMulDelBtn}
                disabledReloadButton={inEditMode}
                disabledExportButton={excelIsGenerating}
                disabledExcelExportButtonV2={excelIsGeneratingV2}
                disabledSpecificOptionButton={selectedItems.length === 0}
                disabledCompareButton={!this.isSpecificItemSelectedInSpecificPSL()}
                disableTransferAssignmentsButton={
                    !isNewGridTable ? (inEditMode || selectedItems.length === 0 || derivates.length <= 0)
                        : (!this.isAnyFilterApplied() || derivates.length <= 0)}
                disableWorkflowStatusMultiUpdateButton={
                    !isNewGridTable ? (inEditMode || selectedItems.length === 0) : true
                }
                disableCheckPCCDSyncronisationButton={
                    !isNewGridTable ? (inEditMode || derivates.length <= 0) : true
                }
                disableUpdateDraftAssignmentsButton={
                    !isNewGridTable ? inEditMode || selectedItems.length === 0 || derivates.length <= 0
                        : true}
                disableHistoryButton={inEditMode || selectedItems.length !== 1}
                disabledSelectLanguageButton={false}

                labelCopyButton={isSpecificMarketLoaded ? t("CREATE_SPECIFIC_COPY") : t("COPY_OPTION")}
                labelDeleteButton={t("DELETE_OPTION")}
                labelMultipleDeleteButton={t("DELETE_OPTION")}
                labelEditButton={!inEditMode ? t("START_EDITING") : t("STOP_EDITING")}
                labelReloadButton={t("RELOAD")}
                labelExportButton={excelIsGenerating ? t('OPTIONS_VIEW:EXCEL_GENERATING') + '...' : t("EXCEL_EXPORT_RAW_DATA_BTN")}
                labelExcelExportButtonV2={excelIsGeneratingV2 ? t('OPTIONS_VIEW:EXCEL_GENERATING') + '...' : t("EXCEL_EXPORT_STANDARD_BTN")}
                labelSpecificOptionButton={t("INIT_SPECIFIC_OPTIONS")}
                labelCompareButton={t('COMPARE_BUTTON')}
                labelTransferAssignmentsButton={t("TRANSFER_ASGN_BTN")}
                labelWorkflowStatusMultiUpdateButton={t("UPDATE_WF_STATUS_MULTI_BTN")}
                labelCheckPCCDSyncronisationButton={t("CHECK_PSL_PCCD_SYNC_BTN")}
                labelUpdateDraftAssignmentsButton={t("UPDATE_DRAFT_ASGN_BTN")}
                labelHistoryButton={t('BASEOPTIONS:SHOW_HISTORY')}
                labelSelectLanguageButton={t('SELECT_LANGUAGES')}
                labelFlagMultiUpdateButton={t("UPDATE_FLAG_MULTI_BTN")}
                labelTextSearch={t("GLOBAL:TEXT_SEARCH")}
                labelValidationFilter={t("GLOBAL:VALIDATION_FILTER_LABEL")}
                isGlobalSearch={this.state.isNewGridTable}
                isNewGridTable={isNewGridTable}
                onResetFilters={this.onResetFilters}
                onClickCopyButton={this.onOptionCopy}

                onClickMultipleDeleteButton={() => {
                    if (selectedItems.length > 1) {
                        this.setState({showMultipleDeleteOptionDlg: true});
                    } else {
                        this.onDeleteOptionButtonClicked();
                    }

                }
                }
                onClickEditButton={() => this.setState({inEditMode: !inEditMode})}
                onClickReloadButton={() => this.setState(
                    {specificTypeOptionFilter: SpecificFilterEnum.SHOW_ALL, assignmentTypeFilter: {filterValues: new Set()}},
                    () => this.props.DynTableReload(true)
                )}
                onClickExportButton={() => this.excelExport({})}
                onClickExcelExportButtonV2={() => this.setExportExcelFlags(true)}
                onClickSpecificOptionButton={() => this.setState({showCreateSpecificMarketDialog: true})}
                onClickCompareButton={() => this.setState({showCompareDialog: true})}
                onClickTransferAssignmentsButton={() => this.setState({showTransferAssignmentsDlg: true})}
                onClickWorkflowStatusMultiUpdateButton={() => this.setState({showWorkflowStatusMultiUpdateDlg: true})}
                onClickCheckPCCDSyncronisationButton={this.onCheckPCCDSyncronisation}
                onClickUpdateDraftAssignmentsButton={() => this.setState({showUpdateDraftAssignments: true})}
                onClickHistoryButton={this.requestBaseOptionHistory}
                onClickSelectLanguageButton={(val: any) => this.onClickSelectLanguage(val)}

                // if a specific market PSL is loaded and a basic market option is selected, display info that the selected option cannot be deleted
                deleteButtonExchangeLabel={this.isBasicMarketItemSelectedInSpecificPSL() ?
                    this.props.t("DELETE_OPTION_SPECIFIC_PSL_INFO") : undefined}
                handleSpecificTypeFilterChange={isSpecificMarketLoaded ? (value: SpecificFilterEnum) => this.setState({specificTypeOptionFilter: value}) : undefined}
                handleAssignmentTypeFilterChange={(value: Set<EOptionState>, missingPDiPAsgn?: boolean) => {
                    if (this.state.isNewGridTable) {
                        this.setState(
                            prevState => {
                                const codes = getOptionStateCodes(value); // value is Set<EOptionState>
                                const newGridFilters = {...prevState.newGridFilters, assignmentFilter: codes};
                                return {
                                    assignmentTypeFilter: {filterValues: value, missingPDiPAsgn},
                                    newGridFilters,
                                    isLoadingData: true,
                                    loadedRows: new Set()
                                };
                            },
                            () => {
                                this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
                            }
                        );
                    } else {
                        this.setState({assignmentTypeFilter: {filterValues: value, missingPDiPAsgn}});
                    }

                }}
                assignmentTypeFilterValue={assignmentTypeFilter}
                specificFilterValue={specificTypeOptionFilter}
                loadedPSL={loadedPSL}
                iconExportButton={excelIsGenerating ? 'hourglass half' : 'file'}
                iconExcelExportButtonV2={excelIsGeneratingV2 ? 'hourglass half' : 'file'}
                selectedLanguages={selectedLanguageList || []}
                languageList={languageList || []}
                onClickFlagMultiUpdate={() => this.setState({showMultipleUpdateFlagDlg: true})}
                onGlobalSearchChange={(value: string) => {
                    const updatedFilters = {...this.state.newGridFilters};
                    if (value) {
                        updatedFilters.isGlobalSearch = true;
                        updatedFilters.text = value;
                    } else {
                        updatedFilters.isGlobalSearch = false;
                        updatedFilters.text = '';
                    }
                    this.setState(
                        {
                            globalSearchText: value,
                            newGridFilters: updatedFilters,
                            isLoadingData: true,
                            loadedRows: new Set(),
                            currentMatchIndex: 0
                        },
                        () => {
                            this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
                        }
                    );
                }}
                isGlobalSearchBtn={this.state.newGridFilters.isGlobalSearch}
                globalSearchText={this.state.globalSearchText}
                goToNextMatch={this.goToNextMatch}
                goToPrevMatch={this.goToPrevMatch}
            />
        );
    }

    private onClickSelectLanguage = (selected: any) => {
        let selectedLanguages = this.state.selectedLanguageList || [];
        if (this.state.languageList) {
            const item = this.state.languageList[selected];
            let checked: boolean = false;
            selectedLanguages.forEach((val: LanguageDto) => {
                if (val.vmce === item.vmce) {
                    checked = true;
                }
            });
            if (checked) {
                selectedLanguages = selectedLanguages.filter((value) => value.vmce !== item.vmce);
            } else {
                selectedLanguages.push(item);
            }
            this.setState({selectedLanguageList: selectedLanguages});
            if (selectedLanguages.length >= 2) {
                this.state.optionRows.forEach(value => value.setSelectedLanguages(selectedLanguages));
            }
        }
    }

    private onCheckPCCDSyncronisation = () => {
        const {client} = this.props;
        const {postOptions} = this.state;
        const canCheck = postOptions && client.GET_pslPCCDSynchronisation(postOptions).canExecute();

        if (!canCheck) {
            this.setModifiing(undefined);
            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }

        this.setModifiing(this.props.t("CHECK_PSL_PCCD_SYNC"));
        // @ts-ignore already checked
        const request = client.GET_pslPCCDSynchronisation(postOptions);
        request.execute()
            .then((value: MissingAssignmentsAndDerivateDTO) => {
                this.setState({
                    showCheckPCCDSyncResultDlg: true,
                    checkPCCDSyncResult: value
                });
            })
            .catch((reason: any) => {
                renderErrorToast({
                    message: "ERRORS:CHECK_PSL_PCCD_SYNC_ERROR",
                    details: reason,
                    timestamp: Date.now()
                });
                this.setModifiing();
            });
    }

    private renderCheckPCCDSyncResultDlg = (): JSX.Element => {
        this.setModifiing();

        return (
            this.state.checkPCCDSyncResult ?
                (
                    <PSLandPCCDSyncDialog
                        result={this.state.checkPCCDSyncResult}
                        t={this.props.t}
                        onClose={() => this.setState({
                            showCheckPCCDSyncResultDlg: false,
                            checkPCCDSyncResult: undefined
                        })}
                    />
                )
                : <></>
        );
    }

    private onDeleteOptionButtonClicked = () => {
        const {selectedItem} = this.state;
        if (selectedItem) {

            if (this.isSpecificItemSelectedInSpecificPSL()) {
                this.setState({isShowDeleteConfirmDialog: true});
            } else {
                this.setModifiing(this.props.t("SEARCH_CHILD_OPTIONS"));
                this.requestChildOptions(selectedItem.value).then((returnResult: boolean) => {
                    if (returnResult) {
                        this.setState({isShowDeleteConfirmDialog: true});
                    }
                    this.setModifiing();
                });
            }
        }
    }

    private createSpecificOptionDialog = (): JSX.Element => {
        const {t} = this.props;

        let title: string = t('CREATE_SPECIFIC_OPTIONS_DIALOG_HEADER');
        let actions: JSX.Element[];
        let content: JSX.Element;

        if (this.areBasicMarketOptionsWithSpecificCopySelectedInSpecificPSL()) {
            actions =
                [
                    <Button key={2} icon={"ban"} label={t("CANCEL")} onClick={() => this.setState({showCreateSpecificMarketDialog: false})} />,
                ];

            content = <p> {t('HAS_SPECIFIC_COPY')} </p>;
        } else if (!this.areBasicMarketOptionsSelectedInSpecificPSL()) {
            actions =
                [
                    <Button key={2} icon={"ban"} label={t("CANCEL")} onClick={() => this.setState({showCreateSpecificMarketDialog: false})} />,
                ];

            content = <p> {t('CAN_INIT_ONLY_FROM_BASIC_MARKET_OPTION')} </p>;
        } else {
            actions = [
                <Button key={1} icon={"check"} label={t("CREATE")} onClick={() => {this.setState({showCreateSpecificMarketDialog: false}, this.createSpecificOptions);}} />,
                <Button key={2} icon={"ban"} label={t("CANCEL")} onClick={() => this.setState({showCreateSpecificMarketDialog: false})} />,
            ];

            content = <p> {t('CREATE_SPECIFIC_OPTIONS_DIALOG_BODY')} </p>;
        }

        return (
            <Dialog
                open={this.state.showCreateSpecificMarketDialog}
                actions={actions}
                title={title}
            >
                {content}
            </Dialog>
        );
    }

    private createSpecificOptions = () => {
        const selectedItems: DataAdapterOptionsView[] = this.state.selectedItems;
        if (selectedItems && this.state.postOptions) {

            const {t} = this.props;
            this.setModifiing(t("CREATE_SPECIFIC_OPTION_LOAD_MESSAGE"));

            const ro = this.props.client.POST_specificOption(this.state.postOptions);
            if (ro.canExecute()) {
                const baseMarketOptions: number[] = selectedItems.map((item: DataAdapterOptionsView) => item.objectId);
                const targetCnr: number | undefined = this.state.loadedPSL ? (this.state.loadedPSL.cnr ? this.state.loadedPSL.cnr.objectId : undefined) : undefined;
                if (targetCnr !== undefined) {
                    let specificOptionsInitDto: SpecificOptionInitDto = {
                        baseMarketOptions: baseMarketOptions,
                        cnrId: targetCnr,
                        specificType: SpecificOptionInitDtoSpecificType.DEPENDENT_OVERWRITE
                    };

                    ro.execute(specificOptionsInitDto).then((res: ResourceListOfOptionDto) => {
                        this.props.DynTableSetSelectedIdList([]);
                        this.reloadData(this.props);
                    }).catch((err) => {
                        renderErrorToast({
                            message: "ERRORS:CREATE_OPTION",
                            details: err,
                            timestamp: Date.now()
                        });
                        this.setModifiing();
                    });
                } else {
                    this.setModifiing();
                }
            } else {
                renderErrorToast({
                    message: "ERRORS:CREATE_OPTION",
                    details: "MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
                this.setModifiing();
            }
        }
    }

    private isBasicMarketItemSelectedInSpecificPSL(): boolean | undefined {
        return this.state.loadedPSL && this.state.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey
            && this.state.selectedItem && this.state.selectedItem.cnr && this.state.selectedItem.cnr.cnr === PropertiesKey.BasicMarketCnrKey;
    }

    private isSpecificItemSelectedInSpecificPSL(): boolean | undefined {
        return this.state.loadedPSL && this.state.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey
            && this.state.selectedItem && this.state.selectedItem.cnr && this.state.selectedItem.cnr.cnr === this.state.loadedPSL.cnr.cnr;
    }

    /**
     *  Returns whether the current view is representing a specific market or not
     */
    private isSpecificMarket = (): boolean | undefined => {
        return this.state.loadedPSL ? this.state.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey : undefined;
    }

    /**
     * Returns true if one or more basic market options (only basic market options) are selected in a specific PSL, false otherwise.
     */
    private areBasicMarketOptionsSelectedInSpecificPSL = (): boolean | undefined => {
        if (this.state.loadedPSL && this.state.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey) {
            const selectedItems: DataAdapterOptionsView[] = this.state.selectedItems;
            let result: boolean = true;
            if (selectedItems.length === 0) {
                result = false;
            }
            selectedItems.forEach((item: DataAdapterOptionsView) => {
                if (item.cnr && item.cnr.cnr !== PropertiesKey.BasicMarketCnrKey) {
                    result = false;
                }
            });
            return result;
        }
        return false;
    }

    /**
     *
     */
    private areBasicMarketOptionsWithSpecificCopySelectedInSpecificPSL = (): boolean => {
        if (this.state.loadedPSL && this.state.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey) {
            const selectedItems: DataAdapterOptionsView[] = this.state.selectedItems;
            if (selectedItems.length === 0) {
                return false;
            }

            return selectedItems.findIndex((item: any) => item.cnr && item.cnr.cnr === PropertiesKey.BasicMarketCnrKey && item.dto.hasSpecificCopy) > -1;
        }

        return false;
    }

    private showOptionCopyDialog() {
        this.setModifiing(undefined);

        const {
            selectedItem,
            isShowCopyOptionDialog,
            loadedPSL,
            optionMTBAConflicts,
            derivates
        } = this.state;

        if (!isShowCopyOptionDialog || !loadedPSL || !selectedItem || !optionMTBAConflicts) {
            return;
        } else {
            return (
                <ModeltypeBasicAssignmentsDialog
                    title={this.props.t("COPY_OPTION", {option: selectedItem.optionBasicView})}
                    dialogText={this.props.t("OPTIONS_VIEW:COPY_OPTION_TEXT")}
                    typefamily={loadedPSL.typefamily}
                    modelyear={selectedItem.optionBasic.modelyear}
                    unavailableDerivates={optionMTBAConflicts}
                    derivates={derivates}
                    derivatesMap={DataAdapterOptionsView.createIdToDerivateMap(derivates, this.props.userLanguage)}
                    onConfirm={this.confirmOptionCopy}
                    onCancel={this.cancelOptionCopy}
                    pdipDerivates={this.state.pdipDerivates || []}
                />
            );
        }
    }

    /** handle confirm action for option copy */
    private confirmOptionCopy = (newValue: DataAdapterOptionsView) => {
        if (this.state.selectedItem) {
            let payload: any = _.set({}, EColumnKey.ObjectIDKey, this.state.selectedItem.dto.objectId);
            payload = _.set(payload, EColumnKey.DerivateKey, newValue);

            this.setState(
                {
                    isShowCopyOptionDialog: false,
                    optionMTBAConflicts: undefined
                },
                () => this.handleCopyOption(payload)
            );
        }
    }

    /** cancel option copy action */
    private cancelOptionCopy = () => {
        this.setState({
            isShowCopyOptionDialog: false,
            optionMTBAConflicts: undefined
        });
    }

    private onOptionCopy = (): void => {
        const {selectedItem, loadedPSL, derivates} = this.state;
        const {client, t} = this.props;

        this.setModifiing(t("GET_MTBA_CONFLICTS"));

        if (!loadedPSL || !selectedItem || !derivates) {
            return;
        }

        const canCopy = client.GET_optionCopyAssignmentsConflicts(selectedItem.dto).canExecute()
            && client.POST_optionCopy(selectedItem.dto).canExecute();

        if (!canCopy) {
            this.setModifiing(undefined);
            renderErrorToast({
                message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }

        const loadedCnrId: number | undefined = this.state.loadedPSL ? (this.state.loadedPSL.cnr ? this.state.loadedPSL.cnr.objectId : undefined) : undefined;
        if (loadedCnrId) {
            const requestParam: GetOptionMTBAConflictsParams = {
                cnrId: loadedCnrId
            };

            const requestMTBAConflicts = client.GET_optionCopyAssignmentsConflicts(selectedItem.dto);
            requestMTBAConflicts.execute(requestParam)
                .then((value: {[key: number]: String[]}) => {
                    this.setState({optionMTBAConflicts: value, isShowCopyOptionDialog: true});
                })
                .catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:GET_MTBA_CONFLICTS",
                        details: reason,
                        timestamp: Date.now()
                    });
                    this.setModifiing();
                });
        }
    }

    private mapDerivateAssignments(newValue: TDerivateStates) {
        const derivateStates: AssignedModeltypeBasicDto[] = [];
        const {derivates} = this.state;
        const derivatesMap = DataAdapterOptionsView.createIdToDerivateMap(derivates, this.props.userLanguage);
        _.forOwn(derivatesMap, (derName, key, object) => {

            if (key in newValue) {
                const dtoObjectId: number = Number(key);
                const assignmentType = DataAdapterOptionsView.getAssigment(newValue[key]);
                let mt = _.find(derivates, (dto: ModeltypeBasicDto) => dto.objectId === dtoObjectId);

                if (mt && assignmentType !== AssignedModeltypeBasicDtoAssignmentType.N) {
                    mt.links = undefined;
                    const derivateState: AssignedModeltypeBasicDto = {
                        assignmentType: assignmentType,
                        modeltypeBasic: mt,
                        objectId: 0,
                        versionId: 0
                    };

                    derivateStates.push(derivateState);
                }
            }
        });

        return derivateStates;
    }

    private handleCopyOption(existingItem: DataAdapterOptionsView) {
        const {derivates, selectedItem, selectedLanguageList} = this.state;
        const {workflows, userCnrs} = this.props;

        const copyingOption = this.props.t("CREATING_OPTION", {option: selectedItem && ColumnFactory.option2str(selectedItem.value)});
        this.setModifiing(copyingOption);

        let assignments: AssignedModeltypeBasicDto[] = [];
        if (existingItem.derivateStates) {
            assignments = this.mapDerivateAssignments(existingItem.derivateStates);
        }

        const cnrId: number | undefined = this.state.loadedPSL ? (this.state.loadedPSL.cnr ? this.state.loadedPSL.cnr.objectId : undefined) : undefined;

        if (cnrId !== undefined) {
            let requestParam: SimpleOptionCopyDto = {
                optionId: existingItem.objectId,
                cnrId: cnrId,
                modeltypeBasicAssignments: assignments.length > 0 ? assignments : undefined
            };

            let optionRows = _.cloneDeep(this.state.optionRows);
            const index = _.findIndex(optionRows, (val: DataAdapterOptionsView) => val.objectId === existingItem.objectId);

            // use data adapter for work on object
            let daVal = optionRows[index];
            let optionDto = daVal.value;
            const canCopy = this.props.client.POST_optionCopy(optionDto).canExecute();

            if (!canCopy) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
            }

            this.props.client.POST_optionCopy(optionDto).execute(requestParam)
                .then((link: Link) => {
                    // request the object from data base
                    return this.props.client.GET_optionSelf(link).execute();
                })
                .then((dto: OptionDto) => {
                    if (this.state.isNewGridTable) {
                        this.setState(
                            {
                                selectedItem: undefined,
                                isLoadingData: true,
                                loadedRows: new Set(),
                                totalElements: 0,
                                currentMatchIndex: 0 // <-- Reset match index on search change
                            },
                            () => {
                                this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
                            }
                        );
                    } else {
                        // add the new type to the list
                        const derivatesMap = DataAdapterOptionsView.createIdToDerivateMap(derivates, this.props.userLanguage);
                        const createdItem = new DataAdapterOptionsView(dto, derivates, derivatesMap, workflows ? workflows : [], selectedLanguageList || [], userCnrs || []);

                        optionDto.hasSpecificCopy = true;

                        // replace the object with updated one
                        const ndto = new DataAdapterOptionsView(
                            optionDto,
                            daVal.derivates,
                            daVal.derivatesMap,
                            daVal.workflows,
                            daVal.languages,
                            daVal.cnrs
                        );

                        optionRows[index] = ndto;
                        let rowsTop = optionRows.slice(0, index + 1);
                        let rowsDown = optionRows.slice(index + 1);

                        this.setState(
                            {
                                optionRows: rowsTop.concat(createdItem, rowsDown)
                            });
                        this.setModifiing();

                    }
                })
                .catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:CREATE_OPTION",
                        details: reason,
                        timestamp: Date.now()
                    });
                    this.setModifiing();
                });
        }
    }

    private childOptionToJSX = (o: OptionDto, key?: string): JSX.Element => {

        let optionCode: string = ColumnFactory.option2str(o);
        let specificType: string = o.specificType ? o.specificType : "";

        let cnr: CnrDto | undefined = this.props.userCnrs.find((_cnr: CnrDto) => _cnr.objectId === o.cnrId);

        return (
            <p key={key}>
                <b>{cnr ? cnr.name : ""}</b>
                <Icon name='arrow right' className='before' />
                <b>{optionCode}</b>
                <Icon name='arrow right' className='before' />
                <b>{specificType}</b>
            </p>
        );
    }

    private showDeleteConfirmDialog() {
        const {selectedItem, isShowDeleteConfirmDialog} = this.state;

        if (selectedItem && isShowDeleteConfirmDialog) {
            // show dialog to confirm the delete
            const t = this.props.t;

            return (
                <DeleteConfirmDialog
                    title={t("DELETE_OPTION_QUESTION", {
                        option: ColumnFactory.option2str(selectedItem.value)
                    }
                    )}
                    onDelete={this.handleDeleteOption}
                    onCancel={() => this.setState({isShowDeleteConfirmDialog: false, childOptions: undefined})}
                >
                    {
                        this.isSpecificItemSelectedInSpecificPSL() ?
                            <p> {t("DELETE_SPECIFIC_OPTION_CONFIRM", {type: selectedItem.specificType})} </p>
                            :
                            <>
                                {this.state.childOptions !== undefined && this.state.childOptions.length > 0 ?
                                    <>
                                        <p> {t('CHILD_MARKETS_FROM_CURRENT')} </p>
                                        {this.state.childOptions.map((o: OptionDto, index: number) => {
                                            return this.childOptionToJSX(o, "child_option_" + index);
                                        })}
                                    </>
                                    : <> {t('NO_CHILD_OPTIONS')} </>}
                                <><p> {t("DELETE_OPTION_CONFIRM")} </p> </>
                            </>
                    }
                </DeleteConfirmDialog>
            );
        } else {
            return null;
        }
    }

    /** deletes modeltype */
    private handleDeleteOption() {
        this.setState({isShowDeleteConfirmDialog: false, childOptions: undefined});

        const {selectedItem} = this.state;
        const {t, client} = this.props;

        if (selectedItem) {
            const dto = selectedItem.value;
            const dr = client.DELETE_option(dto);
            const params =
            {
                option: ColumnFactory.option2str(selectedItem.value)
            };
            let errMsg = "ERRORS:DELETE_OPTION";
            if (!dr.canExecute()) {
                renderErrorToast({
                    message: errMsg,
                    translationOptions: params,
                    details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
            } else {
                const deleting = t("DELETING_OPTION", params);
                this.setModifiing(deleting);
                dr.execute(dto)
                    .then(async () => {
                        if (this.state.isNewGridTable) {
                            this.setState(
                                {
                                    selectedItem: undefined,
                                    isLoadingData: true,
                                    loadedRows: new Set(),
                                    totalElements: 0,
                                    currentMatchIndex: 0 // <-- Reset match index on search change
                                },
                                () => {
                                    this.loadNewGridData(0, this.state.pageSize, this.state.agGridRef);
                                }
                            );
                        } else {
                            // remove the item from the list
                            const optionRows = this.state.optionRows.filter((val: DataAdapterOptionsView) => val.objectId !== selectedItem.objectId);
                            this.setState(
                                {
                                    optionRows: sortOptions(optionRows, this.props.optionTableSort),
                                    selectedItem: undefined
                                });
                            this.props.DynTableSetSelectedIdList([]);

                        }
                        const baseLinks: MenuDto = await this.props.client.GET_baseLinks().execute();
                        const initDto = await this.props.client.GET_initdata(baseLinks).execute();
                        this.props.ReceiveInitDataAction(initDto);

                    })
                    .catch((reason: any) => {
                        renderErrorToast({
                            message: errMsg,
                            translationOptions: params,
                            details: reason,
                            timestamp: Date.now()
                        });
                        this.setModifiing();
                    });
            }
        }
    }

    /**
     * Set the derivate disclaimer as visible when the PSL context copy process is triggered
     * and set in state the value for copy contexts
     */
    private onPSLCopyClick = (copyPSL: PSLCopyType) => {
        const {pslAreaExtraLinks, client} = this.props;
        const canCopy = client.GET_pslCopyStats(pslAreaExtraLinks).canExecute()
            && client.GET_pslCopyConflicts(pslAreaExtraLinks).canExecute()
            && client.POST_pslCopy(pslAreaExtraLinks).canExecute();
        const copyPSLParams = this.parsePSLCopyParams(copyPSL);

        if (canCopy) {
            this.setModifiing(this.props.t("PSL_COPY:COPY_PSL_PARAMS", copyPSLParams));
            this.setState({
                pslCopyContexts: copyPSL,
                showPSLCopyDerivateDisclaimer: true,
                isShowPSLSelectDialog: false
            });
        } else {
            this.handlePSLCopyError("ERRORS:COPY_PSL", "GLOBAL:MISSING_ACCESS_RIGHTS", copyPSLParams);
        }
    }

    /**
     * Render PSL context copy derivate disclaimer dialog
     */
    private renderPSLCopyDerivateDisclaimer = (): JSX.Element | undefined => {
        const {t} = this.props;
        const {pslCopyContexts} = this.state;
        this.setModifiing();

        if (pslCopyContexts) {
            return (
                <Dialog
                    open={true}
                    title={t("PSL_COPY:COPY_PSL_DERIVATE_DISCLAIMER_TITLE")}
                    actions={[
                        (
                            <Button
                                key={"submitButton"}
                                label={t("CONFIRM")}
                                icon={"checkmark"}
                                onClick={() => {
                                    this.setState({
                                        showPSLCopyDerivateDisclaimer: false
                                    });
                                    this.requestPSLCopyCnrsStats();
                                }}
                            />
                        ), (
                            <Button
                                key={"closeButton"}
                                label={t("CANCEL")}
                                icon={"ban"}
                                onClick={() =>
                                    this.setState({
                                        pslCopyContexts: undefined,
                                        showPSLCopyDerivateDisclaimer: false,
                                        isShowPSLSelectDialog: true
                                    })
                                }
                            />
                        )
                    ]}
                >
                    <>
                        <div className={"display--flex margin-bottom--40px"}>
                            <Icon name="warning sign" color="orange" />
                            <p>{this.props.t("PSL_COPY:PSL_COPY_DERIVATE_DISCLAIMER_TXT", this.parsePSLCopyParams(pslCopyContexts))}</p>
                        </div>
                        <div className={"display--flex"}>
                            <Icon name="info" color="blue" />
                            <p>
                                {this.props.t("PSL_COPY:PSL_COPY_ASSIGNMENT_DISCLAIMER_TXT", {type: t("OPTIONS_VIEW:" + AssignedModeltypeBasicDtoAssignmentType.SV)})}
                            </p>
                        </div>
                    </>
                </Dialog>
            );
        }
        return;
    }

    /**
     * Requests the number of specific options per source PSL market
     * and sets visible the dialog that will display this data
     * (info + confirmation purpose)
     */
    private requestPSLCopyCnrsStats = () => {
        const {pslAreaExtraLinks, client} = this.props;
        const {pslCopyContexts} = this.state;

        if (pslCopyContexts) {

            const reqStats = client.GET_pslCopyStats(pslAreaExtraLinks);
            if (reqStats.canExecute()) {
                this.setModifiing(this.props.t("PSL_COPY:GET_PSL_COPY_CNR_STATS"));

                const reqStatsParam: GetPSLCopyStatsParams = {
                    modelyearId: pslCopyContexts.sourceModelyear.objectId,
                    typefamilyId: pslCopyContexts.sourceTypefamily.objectId
                };

                reqStats.execute(reqStatsParam)
                    .then((stats: {[key: number]: number}) => {
                        this.setState({
                            showPSLCopyCnrsStats: true,
                            pslCopyCnrsStats: stats
                        });
                    }).catch((reason: any) => {
                        this.handlePSLCopyError("ERRORS:GET_PSL_COPY_CNR_STATS", reason);
                        this.setModifiing();
                    });
            } else {
                this.handlePSLCopyError("ERRORS:GET_PSL_COPY_CNR_STATS", "GLOBAL:MISSING_ACCESS_RIGHTS");
            }
        }
    }

    /**
     * Render PSL copy option's market distribution
     */
    private renderPSLCopyCnrsStats = (): JSX.Element | undefined => {
        const {pslCopyContexts, pslCopyCnrsStats} = this.state;

        this.setModifiing();

        if (pslCopyContexts) {
            return (
                <PSLCopyStatsDialog
                    pslCopyContexts={pslCopyContexts}
                    stats={pslCopyCnrsStats ? pslCopyCnrsStats : {}}
                    onConfirm={() => {
                        this.setState({
                            pslCopyCnrsStats: undefined,
                            showPSLCopyCnrsStats: false,
                        });
                        this.requestPSLCopyConflicts();
                    }}
                    onCancel={() => {
                        this.setState({
                            pslCopyContexts: undefined,
                            pslCopyCnrsStats: undefined,
                            showPSLCopyCnrsStats: false,
                            isShowPSLSelectDialog: true
                        });
                    }}
                />
            );
        }
        return;
    }

    /** Requests the conflicts between PSL copy contexts.
     * If the response is empty, then the copy process continues,
     * otherwise a dialog that displayes the conflists will be visible
     */
    private requestPSLCopyConflicts = () => {
        const {pslAreaExtraLinks, client} = this.props;
        const {pslCopyContexts} = this.state;
        if (pslCopyContexts) {

            const reqConflicts = client.GET_pslCopyConflicts(pslAreaExtraLinks);
            if (reqConflicts.canExecute()) {
                this.setModifiing(this.props.t("PSL_COPY:COPY_PSL_GET_CONFLICTS", this.parsePSLCopyParams(pslCopyContexts)));

                const reqParams: GetPSLCopyConflictsParams = {
                    sourceModelyearId: pslCopyContexts.sourceModelyear.objectId,
                    sourceTypefamilyId: pslCopyContexts.sourceTypefamily.objectId,
                    targetModelyearId: pslCopyContexts.targetModelyear.objectId,
                    targetTypefamilyId: pslCopyContexts.targetTypefamily.objectId
                };

                reqConflicts.execute(reqParams)
                    .then((response: PSLCopyConflictDto[]) => {
                        if (response.length > 0) {
                            this.setState({
                                pslCopyConflicts: response,
                                showPSLCopyConflicts: true
                            });
                        } else {
                            this.handlePSLCopy();
                        }
                    }).catch((reason: any) => {
                        this.handlePSLCopyError("ERRORS:COPY_PSL_GET_CONFLICTS", reason);
                        this.setModifiing();
                    });
            } else {
                this.handlePSLCopyError("ERRORS:COPY_PSL_GET_CONFLICTS", "GLOBAL:MISSING_ACCESS_RIGHTS");
            }
        }
    }

    /**
     * Renders the PSL copy conflicts dialog
     */
    private renderPSLCopyConflicts = (): JSX.Element | undefined => {
        this.setModifiing();

        if (this.state.pslCopyContexts) {
            return (
                <PSLCopyConflictsDialog
                    pslCopyConflictList={this.state.pslCopyConflicts ? this.state.pslCopyConflicts : []}
                    pslCopyParams={this.parsePSLCopyParams(this.state.pslCopyContexts)}
                    onConfirm={() => {
                        this.setState({
                            pslCopyConflicts: undefined,
                            showPSLCopyConflicts: false,
                        });
                        this.handlePSLCopy();
                    }}
                    onClose={() => {
                        this.setState({
                            pslCopyContexts: undefined,
                            pslCopyConflicts: undefined,
                            showPSLCopyConflicts: false,
                            isShowPSLSelectDialog: true
                        });
                    }}
                />
            );
        }
        return;
    }

    /**
     * Trigger final copy PSL action
     */
    private handlePSLCopy = () => {
        const {pslAreaExtraLinks, client} = this.props;
        const {pslCopyContexts} = this.state;
        if (pslCopyContexts) {

            const copyParams = this.parsePSLCopyParams(pslCopyContexts);
            const postCopyRequest = client.POST_pslCopy(pslAreaExtraLinks);

            if (postCopyRequest.canExecute()) {
                this.setModifiing(this.props.t("PSL_COPY:COPY_PSL_PARAMS", copyParams));

                const reqParams: GetPSLCopyParams = {
                    sourceModelyearId: pslCopyContexts.sourceModelyear.objectId,
                    sourceTypefamilyId: pslCopyContexts.sourceTypefamily.objectId,
                    targetModelyearId: pslCopyContexts.targetModelyear.objectId,
                    targetTypefamilyId: pslCopyContexts.targetTypefamily.objectId
                };

                postCopyRequest.execute(reqParams)
                    .then((response: PSLCopyResultSummaryDto) => {
                        this.setState({
                            pslCopyResultSummary: response,
                            showPSLCopyResultSummary: true
                        });
                    }).catch((reason: any) => {
                        this.handlePSLCopyError("ERRORS:COPY_PSL", reason, copyParams);
                        this.setModifiing();
                    });
            } else {
                this.handlePSLCopyError("ERRORS:COPY_PSL", "GLOBAL:MISSING_ACCESS_RIGHTS", copyParams);
            }
        }
    }

    /**
     * Render PSL copy result summary
     */
    private renderPSLCopyResultSummary = (): JSX.Element | undefined => {
        this.setModifiing();

        if (this.state.pslCopyResultSummary) {
            return (
                <PSLCopyResultSummaryDialog
                    pslCopyResultSummary={this.state.pslCopyResultSummary}
                    onConfirm={() => {
                        this.setState({
                            pslCopyContexts: undefined,
                            pslCopyResultSummary: undefined,
                            showPSLCopyResultSummary: false,
                            isShowPSLSelectDialog: true
                        });
                    }}
                />
            );
        }
        return;
    }

    /**
     * Helper function for parsing PSL copy parameters
     */
    private parsePSLCopyParams(copyPSL: PSLCopyType) {
        const copyPSLParams =
        {
            sourceModelyear: ColumnFactory.mj2str(copyPSL.sourceModelyear),
            sourceTypefamily: copyPSL.sourceTypefamily.name,

            targetModelyear: ColumnFactory.mj2str(copyPSL.targetModelyear),
            targetTypefamily: copyPSL.targetTypefamily.name
        };
        return copyPSLParams;
    }

    /**
     * Helper function for error handling during the PSL copy process
     */
    private handlePSLCopyError(message: string, details: string, msgParams?: any) {
        const error: IError = {
            message: message,
            translationOptions: msgParams,
            details: details,
            timestamp: Date.now()
        };

        if (this.state.loadedPSL) {
            this.redirectToPSL(this.state.loadedPSL, true);
            renderErrorToast(error);
        } else {
            this.redirectToMain(error);
        }
    }

    /**
     *
     */
    renderAMTBTransferDlg = (): JSX.Element | undefined => {
        return (
            <OptionAMTBTransferDialog
                derivates={this.state.derivates}
                items={this.state.selectedItems}
                errorTransferResult={this.state.amtbTransferResult}
                userLanguage={this.props.userLanguage}
                onSubmit={(val: AssignmentTransferDto) => this.handleAMTBTransfer(val)}
                onClose={() =>
                    this.setState({
                        showTransferAssignmentsDlg: false,
                        amtbTransferResult: undefined
                    })
                }
                onRefresh={() => {
                    this.setState(
                        {
                            showTransferAssignmentsDlg: false,
                            amtbTransferResult: undefined
                        },
                        () => this.props.DynTableReload(true)
                    );
                }}
            />
        );
    }

    private handleAMTBTransfer(param: AssignmentTransferDto) {
        if (this.state.postOptions
            && this.props.client.PATCH_optionTranferAssignments(this.state.postOptions)) {
            this.props.client.PATCH_optionTranferAssignments(this.state.postOptions).execute(param)
                .then((result: {[key: number]: string}) => {
                    this.setState({amtbTransferResult: result});
                }).catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:TRANSFER_AMTB_ERROR",
                        details: reason,
                        timestamp: Date.now()
                    });

                    this.setState({showTransferAssignmentsDlg: false});
                });
        } else {
            renderErrorToast({
                message: "ERRORS:TRANSFER_AMTB_ERROR",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });

            this.setState({showTransferAssignmentsDlg: false});
        }
    }

    renderUpdateDraftAssignmentsDlg = (): JSX.Element => {
        return (
            <UpdateDraftAssignmentsDialog
                derivates={this.state.derivates}
                selectedItems={this.state.selectedItems}
                errorUpdateResult={this.state.updateDraftAssignmentsResult}
                userLanguage={this.props.userLanguage}
                t={this.props.t}
                onSubmit={(val: UpdateDraftAssignmentsDto) => this.handleUpdateDraftAssignments(val)}
                onClose={() =>
                    this.setState({
                        showUpdateDraftAssignments: false,
                        updateDraftAssignmentsResult: undefined
                    })
                }
                onRefresh={() => {
                    this.setState(
                        {
                            showUpdateDraftAssignments: false,
                            updateDraftAssignmentsResult: undefined
                        },
                        () => this.props.DynTableReload(true)
                    );
                }}
            />
        );
    }

    private handleUpdateDraftAssignments(param: UpdateDraftAssignmentsDto) {
        if (this.state.postOptions
            && this.props.client.PATCH_optionDraftAssignments(this.state.postOptions)) {
            this.props.client.PATCH_optionDraftAssignments(this.state.postOptions).execute(param)
                .then((result: {[key: number]: string}) => {
                    this.setState({updateDraftAssignmentsResult: result});
                }).catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:UPDATE_DARFT_ASGN_ERROR",
                        details: reason,
                        timestamp: Date.now()
                    });

                    this.setState({showUpdateDraftAssignments: false});
                });
        } else {
            renderErrorToast({
                message: "ERRORS:UPDATE_DARFT_ASGN_ERROR",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });

            this.setState({showUpdateDraftAssignments: false});
        }
    }

    renderWorkflowStatusMultiUpdateDlg = (): JSX.Element => {
        return (
            <UpdateWorkflowStatusMultiDialog
                items={this.state.selectedItems}
                workflowStatusMultiUpdateErrorResult={this.state.workflowStatusMultiUpdateErrorResult}
                onSubmit={this.handleWorkflowStatusMultiUpdate}
                onClose={() => {
                    this.setState({
                        showWorkflowStatusMultiUpdateDlg: false,
                        workflowStatusMultiUpdateErrorResult: undefined
                    });
                }}
                onRefresh={() => {
                    this.setState(
                        {
                            showWorkflowStatusMultiUpdateDlg: false,
                            workflowStatusMultiUpdateErrorResult: undefined
                        },
                        () => this.props.DynTableReload(true)
                    );
                }}
            />
        );
    }

    private handleWorkflowStatusMultiUpdate = (param: OptionWorkflowStatusMultiUpdateParam) => {
        if (this.state.postOptions
            && this.props.client.PATCH_optionWorkflowStatusMultiUpdate(this.state.postOptions)) {
            this.props.client.PATCH_optionWorkflowStatusMultiUpdate(this.state.postOptions).execute(param)
                .then((result: number) => {
                    this.setState({workflowStatusMultiUpdateErrorResult: result});
                }).catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:OPTION_WORKFLOW_STATUS_MULTI_UPDATE",
                        details: reason,
                        timestamp: Date.now()
                    });

                    this.setState({showWorkflowStatusMultiUpdateDlg: false});
                });
        } else {
            renderErrorToast({
                message: "ERRORS:OPTION_WORKFLOW_STATUS_MULTI_UPDATE",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });

            this.setState({showWorkflowStatusMultiUpdateDlg: false});
        }
    }

    private handleMultipleOptionDeletion = (options: DtoListWithLinksOfOptionDto) => {
        if (this.state.postOptions
            && this.props.client.DELETE_optionMultipleDelete(this.state.postOptions)) {
            this.props.client.DELETE_optionMultipleDelete(this.state.postOptions).execute(options)
                .then((result: number[]) => {
                    this.setState({multipleOptionDeletionResult: result});
                }).catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:OPTION_MULTIPLE_DELETE",
                        details: reason,
                        timestamp: Date.now()
                    });

                    this.setState({showMultipleDeleteOptionDlg: false});
                });
        } else {
            renderErrorToast({
                message: "ERRORS:OPTION_MULTIPLE_DELETE",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });

            this.setState({showMultipleDeleteOptionDlg: false});
        }
    }

    private renderMultipleOptionDeletionDlg = (): JSX.Element => {
        return (
            <MultipleOptionDeletionDialog
                items={this.state.selectedItems}
                multipleOptionDeletionResult={this.state.multipleOptionDeletionResult}
                onSubmit={this.handleMultipleOptionDeletion}
                onClose={() => {
                    this.setState({
                        showMultipleDeleteOptionDlg: false,
                        multipleOptionDeletionResult: undefined
                    });
                }}
                onRefresh={() => {
                    this.setState(
                        {
                            showMultipleDeleteOptionDlg: false,
                            multipleOptionDeletionResult: undefined
                        },
                        () => this.props.DynTableReload(true)
                    );
                }}
            />
        );
    }
    private handleFlagMultiUpdate = (param: OptionFlagMultiUpdateParam) => {
        if (this.state.postOptions
            && this.props.client.PATCH_optionFlagsMultiUpdate(this.state.postOptions)) {
            this.props.client.PATCH_optionFlagsMultiUpdate(this.state.postOptions).execute(param)
                .then((result: DataAdapterOptionsView[]) => {
                    const updatedOptionsRow = this.state.optionRows.map(item => {
                        const checkIfExist = result.find(p => p.objectId === item.objectId);
                        if (checkIfExist) {
                            // @ts-ignore
                            item.dto.versionId = checkIfExist.versionId;
                            item.dto.flags = checkIfExist.flags;
                        }
                        return item;
                    });
                    const errorCount = param.options.length;
                    this.setState({optionRows: [...updatedOptionsRow], flagMultiUpdateErrorResult: errorCount - result.length});
                }).catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:OPTION_WORKFLOW_STATUS_MULTI_UPDATE",
                        details: reason,
                        timestamp: Date.now()
                    });

                    this.setState({showMultipleUpdateFlagDlg: false});
                });
        } else {
            renderErrorToast({
                message: "ERRORS:OPTION_WORKFLOW_STATUS_MULTI_UPDATE",
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });

            this.setState({showMultipleUpdateFlagDlg: false});
        }
    }
    renderFlagMultiUpdateDlg = (): JSX.Element => {
        return (
            <FlagMultiUpdateDialog
                items={this.state.selectedItems}
                flagMultiUpdateErrorResult={this.state.flagMultiUpdateErrorResult}
                onSubmit={this.handleFlagMultiUpdate}
                flags={this.props.flags.elements}
                onClose={() => {
                    this.setState({
                        showMultipleUpdateFlagDlg: false,
                        flagMultiUpdateErrorResult: undefined
                    });
                }}
                onRefresh={() => {
                    this.setState(
                        {
                            showMultipleUpdateFlagDlg: false,
                            flagMultiUpdateErrorResult: undefined
                        }
                    );
                }}
            />
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userSettings: selectUserSettings(state),
    switchHeaderMode: selectSwitchHeaderMode(state),
    baseLinks: selectBaseLinks(state),
    client: selectClient(state),
    dynTableReload: selectVirtualizedTableReload(state),
    optionTableSort: selectOptionTableSort(state),
    hideEmptyAssignmentsRowsAndColumns: selectHideEmptyAssignmentsRowsAndColumns(state),
    userRoles: selectUserRoles(state),
    flags: selectFlags(state),
    userCnrs: selectUserCnrs(state),
    pslAreaExtraLinks: selectPslAreaExtraLinks(state),
    settingsDaemon: selectSettingDaemon(state),
    languageList: selectLanguageList(state),
    workflows: selectWorkflows(state),
    userTypefamiliesMap: selectUserTypefamiliesMap(state),
    userPSLModelyears: selectUserPSLModelyears(state),
    userLanguage: selectLanguage(state)
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    AddTranslationLocation: (translation) => dispatch(GeneralActions.AddTranslationLocation(translation)),
    ReceivePSLAreaExtraLinksAction: (extraLinks) => dispatch(OptionViewActions.ReceivePSLAreaExtraLinksAction(extraLinks)),
    AddRecentDocument: (appLink) => dispatch(GeneralActions.AddRecentDocument(appLink)),
    DynTableSetSelectedIdList: (idList) => dispatch(GeneralActions.DynTableSetSelectedIdList(idList)),
    GetWorkflows: (t) => dispatch(GeneralActions.GetWorkflows(t)),
    GetTextFlags: (t) => dispatch(AdminViewActions.GetTextFlags(t)),
    DynTableReload: (dynTableReload) => dispatch(GeneralActions.DynTableReload(dynTableReload)),
    SetOptionTableSort: (sortObject) => dispatch(OptionViewActions.SetOptionTableSort(sortObject)),
    RemoveLoadingMessage: (message) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    AddLoadingMessage: (message) => dispatch(GeneralActions.AddLoadingMessage(message)),
    SetHideEmptyAssignmentsRowsAndColumns: (value) => dispatch(OptionViewActions.SetHideEmptyAssignmentsRowsAndColumns(value)),
    DynTableRollBack: (dynTabelRollback) => dispatch(GeneralActions.DynTableRollBack(dynTabelRollback)),
    ChangeOptionsViewUserSettings: (newSettings) => dispatch(OptionViewActions.ChangeOptionsViewUserSettings(newSettings)),
    ReceiveInitDataAction: (dto) => dispatch(GeneralActions.ReceiveInitDataAction(dto)),
});

export default compose<React.ComponentType<any>>(
    translate(["OPTIONS_VIEW", "SM_OPTIONS_VIEW", "PSL_COPY", "AMTB_TRANSFER", "TEXT_FLAG", "BASEOPTIONS", "HISTORY"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(OptionsView);



// WEBPACK FOOTER //
// ./src/views/OptionsView/OptionsView.tsx